var _style, _g, _g2, _g3, _g4, _circle, _ellipse, _circle2, _path, _g5, _g6, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _polygon, _path9, _rect, _path10, _path11, _path12, _path13, _path14, _path15, _g7, _g8, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _g9, _path34, _g10, _path35, _polygon2, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _g11, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _circle3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg404Vector(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 750 500",
    style: {
      enableBackground: "new 0 0 750 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E0E0E0;}\n\t.st1{fill:#F5F5F5;}\n\t.st2{fill:#EBEBEB;}\n\t.st3{fill:#FAFAFA;}\n\t.st4{fill:#FFFFFF;}\n\t.st5{fill:#263238;}\n\t.st6{fill:#455A64;}\n\t.st7{opacity:0.3;fill:#FFFFFF;enable-background:new    ;}\n\t.st8{fill:url(#SVGID_1_);}\n\t.st9{opacity:0.9;fill:#FFFFFF;enable-background:new    ;}\n\t.st10{fill:url(#SVGID_00000121986574026259758230000002161900082472943777_);}\n\t.st11{opacity:0.8;fill:#FFFFFF;enable-background:new    ;}\n\t.st12{fill:url(#SVGID_00000054980113480346908610000007748911012902988941_);}\n\t.st13{fill:url(#SVGID_00000154415963029759409650000003874797219075967919_);}\n\t.st14{fill:url(#SVGID_00000074438053004666396980000011905764056421877138_);}\n\t.st15{fill:url(#SVGID_00000153669419241486791310000002788771154325535393_);}\n\t.st16{fill:url(#SVGID_00000173867271842188457890000013117252162971816836_);}\n\t.st17{fill:url(#SVGID_00000093163087864778973930000013556549612460973223_);}\n\t.st18{fill:url(#SVGID_00000074440812898844560060000007358536800798496936_);}\n\t.st19{fill:url(#SVGID_00000162328127109419767420000007351187161369757833_);}\n\t.st20{fill:url(#SVGID_00000167376782779433303770000014226688512425503899_);}\n\t.st21{fill:url(#SVGID_00000134955946625449977500000011356449823515877251_);}\n\t.st22{fill:url(#SVGID_00000036226031181725238060000007975002659376342925_);}\n\t.st23{fill:url(#SVGID_00000132778412244809311260000013776747269433501060_);}\n\t.st24{fill:url(#SVGID_00000047024496677227246990000015418697733605706940_);}\n\t.st25{opacity:0.6;}\n\t.st26{fill:#F7C1A3;}\n\t.st27{fill:url(#SVGID_00000130614453820134652870000011437491537807744644_);}\n\t.st28{fill:url(#SVGID_00000029042859484800075110000016130593751880947877_);}\n\t.st29{fill:url(#SVGID_00000099646748241135442720000003773107923787880612_);}\n\t.st30{fill:#F39E78;}\n\t.st31{fill:url(#SVGID_00000057133011338176491620000010103288987687153573_);}\n\t.st32{opacity:0.3;}\n\t.st33{fill:url(#SVGID_00000047755077700726249210000009800558861279100072_);}\n\t.st34{fill:url(#SVGID_00000058589827275949047990000015529805485053299599_);}\n\t.st35{opacity:0.3;enable-background:new    ;}\n\t.st36{fill:url(#SVGID_00000020375084831569744280000014842468720090003856_);}\n\t.st37{fill:url(#SVGID_00000081612550451496825810000011637624306753432765_);}\n\t.st38{fill:url(#SVGID_00000067214310343744929160000008969745307995984523_);}\n\t.st39{fill:url(#SVGID_00000154398863291932660280000012813334497917457283_);}\n\t.st40{fill:url(#SVGID_00000180334925958232783780000013181059293699672487_);}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M727.7,347.4c0,0.1-157.9,0.3-352.7,0.3s-352.7-0.1-352.7-0.3s157.9-0.3,352.7-0.3S727.7,347.2,727.7,347.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 679.9,
    y: 249.1,
    className: "st1",
    width: 31.1,
    height: 98.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 695.5,
    y: 249.1,
    className: "st2",
    width: 15.6,
    height: 98.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 683.5,
    y: 239.4,
    className: "st1",
    width: 11,
    height: 9.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 691.9,
    y: 239.4,
    className: "st2",
    width: 2.6,
    height: 9.7
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "677.3,249.1 677.3,248.5 712,248.5 712,249.1  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 686.1,
    y: 253.3,
    className: "st3",
    width: 2.6,
    height: 5.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M695.5,261c0,0.1-3.5,0.1-7.8,0.1s-7.8,0-7.8-0.1s3.5-0.1,7.8-0.1S695.5,261,695.5,261z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 701.8,
    y: 253.3,
    className: "st0",
    width: 2.6,
    height: 5.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M711.2,261c0,0.1-3.5,0.1-7.8,0.1s-7.8,0-7.8-0.1s3.5-0.1,7.8-0.1S711.2,261,711.2,261z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 701.8,
    y: 264.3,
    className: "st0",
    width: 2.6,
    height: 5.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M711.2,272c0,0-3.5,0.1-7.8,0.1s-7.8,0-7.8-0.1s3.5-0.1,7.8-0.1S711.2,272,711.2,272z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 701.8,
    y: 275.7,
    className: "st0",
    width: 2.6,
    height: 5.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M711.2,283.4c0,0.1-3.5,0.1-7.8,0.1s-7.8,0-7.8-0.1s3.5-0.1,7.8-0.1S711.2,283.4,711.2,283.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 701.8,
    y: 287,
    className: "st0",
    width: 2.6,
    height: 5.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M711.2,294.8c0,0.1-3.5,0.1-7.8,0.1s-7.8,0-7.8-0.1s3.5-0.1,7.8-0.1S711.2,294.7,711.2,294.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 701.8,
    y: 298.1,
    className: "st0",
    width: 2.6,
    height: 5.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M711.2,305.8c0,0.1-3.5,0.1-7.8,0.1s-7.8,0-7.8-0.1s3.5-0.1,7.8-0.1S711.2,305.7,711.2,305.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 701.8,
    y: 309.1,
    className: "st0",
    width: 2.6,
    height: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 701.8,
    y: 320.4,
    className: "st0",
    width: 2.6,
    height: 5.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M711.2,316.9c0,0.1-3.5,0.1-7.8,0.1s-7.8,0-7.8-0.1s3.5-0.1,7.8-0.1S711.2,316.8,711.2,316.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 686.1,
    y: 264.5,
    className: "st3",
    width: 2.6,
    height: 5.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M695.5,272.2c0,0.1-3.5,0.1-7.8,0.1s-7.8,0-7.8-0.1s3.5-0.1,7.8-0.1S695.5,272.2,695.5,272.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 686.1,
    y: 275.7,
    className: "st3",
    width: 2.6,
    height: 5.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M695.5,283.4c0,0.1-3.5,0.1-7.8,0.1s-7.8,0-7.8-0.1s3.5-0.1,7.8-0.1S695.5,283.4,695.5,283.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 686.1,
    y: 286.9,
    className: "st3",
    width: 2.6,
    height: 5.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M695.5,294.6c0,0-3.5,0.1-7.8,0.1s-7.8,0-7.8-0.1s3.5-0.1,7.8-0.1S695.5,294.5,695.5,294.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 686.1,
    y: 298.1,
    className: "st3",
    width: 2.6,
    height: 5.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M695.5,305.8c0,0.1-3.5,0.1-7.8,0.1s-7.8,0-7.8-0.1s3.5-0.1,7.8-0.1S695.5,305.7,695.5,305.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 686.1,
    y: 309.3,
    className: "st3",
    width: 2.6,
    height: 5.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M695.5,317c0,0.1-3.5,0.1-7.8,0.1s-7.8,0-7.8-0.1s3.5-0.1,7.8-0.1S695.5,316.9,695.5,317z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 686.1,
    y: 320.5,
    className: "st3",
    width: 2.6,
    height: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 530.2,
    y: 127.8,
    className: "st2",
    width: 38.2,
    height: 99.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 549.3,
    y: 127.8,
    className: "st0",
    width: 19.1,
    height: 99.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 534.6,
    y: 116,
    className: "st2",
    width: 13.5,
    height: 11.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 544.8,
    y: 116,
    className: "st0",
    width: 3.2,
    height: 11.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 527,
    y: 127.2,
    className: "st0",
    width: 42.5,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 537.7,
    y: 133,
    className: "st4",
    width: 3.2,
    height: 6.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M549.3,142.5c0,0.1-4.3,0.1-9.5,0.1s-9.5-0.1-9.5-0.1s4.3-0.1,9.5-0.1S549.3,142.4,549.3,142.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 557,
    y: 133,
    className: "st1",
    width: 3.2,
    height: 6.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M568.5,142.5c0,0.1-4.3,0.1-9.5,0.1s-9.5-0.1-9.5-0.1s4.3-0.1,9.5-0.1S568.5,142.4,568.5,142.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 557,
    y: 146.5,
    className: "st1",
    width: 3.2,
    height: 6.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M568.5,156c0,0.1-4.3,0.1-9.5,0.1s-9.5-0.1-9.5-0.1s4.3-0.1,9.5-0.1S568.5,156,568.5,156z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 557,
    y: 160.5,
    className: "st1",
    width: 3.2,
    height: 6.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M568.5,170c0,0.1-4.3,0.1-9.5,0.1s-9.5-0.1-9.5-0.1s4.3-0.1,9.5-0.1S568.5,169.9,568.5,170z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 557,
    y: 174.4,
    className: "st1",
    width: 3.2,
    height: 6.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M568.5,183.9c0,0.1-4.3,0.1-9.5,0.1s-9.5-0.1-9.5-0.1s4.3-0.1,9.5-0.1S568.5,183.8,568.5,183.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 557,
    y: 187.9,
    className: "st1",
    width: 3.2,
    height: 6.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M568.5,197.4c0,0.1-4.3,0.1-9.5,0.1s-9.5-0.1-9.5-0.1s4.3-0.1,9.5-0.1S568.5,197.4,568.5,197.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 557,
    y: 201.5,
    className: "st1",
    width: 3.2,
    height: 6.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 557,
    y: 215.3,
    className: "st1",
    width: 3.2,
    height: 6.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M568.5,211c0,0.1-4.3,0.1-9.5,0.1s-9.5-0.1-9.5-0.1s4.3-0.1,9.5-0.1S568.5,210.9,568.5,211z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 537.7,
    y: 146.8,
    className: "st4",
    width: 3.2,
    height: 6.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M549.3,156.2c0,0.1-4.3,0.1-9.5,0.1s-9.5-0.1-9.5-0.1s4.3-0.1,9.5-0.1S549.3,156.2,549.3,156.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 537.7,
    y: 160.5,
    className: "st4",
    width: 3.2,
    height: 6.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M549.3,170c0,0.1-4.3,0.1-9.5,0.1s-9.5-0.1-9.5-0.1s4.3-0.1,9.5-0.1S549.3,169.9,549.3,170z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 537.7,
    y: 174.2,
    className: "st4",
    width: 3.2,
    height: 6.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M549.3,183.7c0,0.1-4.3,0.1-9.5,0.1s-9.5-0.1-9.5-0.1s4.3-0.1,9.5-0.1S549.3,183.6,549.3,183.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 537.7,
    y: 187.9,
    className: "st4",
    width: 3.2,
    height: 6.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M549.3,197.4c0,0.1-4.3,0.1-9.5,0.1s-9.5-0.1-9.5-0.1s4.3-0.1,9.5-0.1S549.3,197.4,549.3,197.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 537.7,
    y: 201.7,
    className: "st4",
    width: 3.2,
    height: 6.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M549.3,211.1c0,0.1-4.3,0.1-9.5,0.1s-9.5-0.1-9.5-0.1s4.3-0.1,9.5-0.1S549.3,211.1,549.3,211.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 537.7,
    y: 215.4,
    className: "st4",
    width: 3.2,
    height: 6.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442.6,
    y: 260.4,
    className: "st0",
    width: 45.1,
    height: 85.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466.5,
    y: 260.4,
    className: "st2",
    width: 21.1,
    height: 85.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452,
    y: 268.4,
    className: "st1",
    width: 4,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452,
    y: 306.9,
    className: "st1",
    width: 4,
    height: 9.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M466.5,282.1c0,0.1-5.4,0.1-12,0.1s-12-0.1-12-0.1s5.4-0.1,12-0.1S466.5,282,466.5,282.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452,
    y: 287.8,
    className: "st1",
    width: 4,
    height: 9.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M466.5,301.5c0,0.1-5.4,0.1-12,0.1s-12-0.1-12-0.1s5.4-0.2,12-0.2S466.5,301.4,466.5,301.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 471,
    y: 268.4,
    className: "st0",
    width: 4,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 479.8,
    y: 268.4,
    className: "st0",
    width: 4,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 471,
    y: 287.1,
    className: "st0",
    width: 4,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 479.8,
    y: 287.1,
    className: "st0",
    width: 4,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 471,
    y: 305.8,
    className: "st0",
    width: 4,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 479.8,
    y: 305.8,
    className: "st0",
    width: 4,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 439.2,
    y: 258.3,
    className: "st0",
    width: 51.8,
    height: 2.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M487.9,260.6c0,0.1-10.1,0.1-22.5,0.1s-22.5-0.1-22.5-0.1s10.1-0.2,22.5-0.2S487.9,260.6,487.9,260.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 615.9,
    y: 183.6,
    className: "st1",
    width: 43.3,
    height: 137.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 637.5,
    y: 183.6,
    className: "st2",
    width: 21.7,
    height: 136.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620.8,
    y: 170.1,
    className: "st1",
    width: 15.3,
    height: 13.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 632.5,
    y: 170.1,
    className: "st2",
    width: 3.7,
    height: 13.5
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "612.3,183.6 612.3,182.8 660.5,182.8 660.5,183.6  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 624.4,
    y: 189.5,
    className: "st3",
    width: 3.7,
    height: 7.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M637.5,200.2c0,0.1-4.8,0.1-10.8,0.1s-10.8-0.1-10.8-0.1s4.8-0.1,10.8-0.1S637.5,200.2,637.5,200.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 646.3,
    y: 189.5,
    className: "st0",
    width: 3.7,
    height: 7.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M659.4,200.2c0,0.1-4.8,0.1-10.8,0.1s-10.8-0.1-10.8-0.1s4.8-0.1,10.8-0.1S659.4,200.2,659.4,200.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 646.3,
    y: 204.8,
    className: "st0",
    width: 3.7,
    height: 7.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M659.4,215.6c0,0.1-4.8,0.1-10.8,0.1s-10.8-0.1-10.8-0.1s4.8-0.1,10.8-0.1S659.4,215.5,659.4,215.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 646.3,
    y: 220.6,
    className: "st0",
    width: 3.7,
    height: 7.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M659.4,231.4c0,0.1-4.8,0.1-10.8,0.1s-10.8-0.1-10.8-0.1s4.8-0.1,10.8-0.1S659.4,231.3,659.4,231.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 646.3,
    y: 236.4,
    className: "st0",
    width: 3.7,
    height: 7.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M659.4,247.2c0,0.1-4.8,0.1-10.8,0.1s-10.8-0.1-10.8-0.1s4.8-0.1,10.8-0.1S659.4,247.1,659.4,247.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 646.3,
    y: 251.8,
    className: "st0",
    width: 3.7,
    height: 7.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M659.4,262.6c0,0.1-4.8,0.1-10.8,0.1s-10.8-0.1-10.8-0.1s4.8-0.1,10.8-0.1S659.4,262.5,659.4,262.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 646.3,
    y: 267.2,
    className: "st0",
    width: 3.7,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 646.3,
    y: 282.9,
    className: "st0",
    width: 3.7,
    height: 7.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M659.4,278c0,0.1-4.8,0.1-10.8,0.1s-10.8-0.1-10.8-0.1s4.8-0.1,10.8-0.1S659.4,277.9,659.4,278z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 624.4,
    y: 205.1,
    className: "st3",
    width: 3.7,
    height: 7.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M637.5,215.8c0,0.1-4.8,0.1-10.8,0.1s-10.8-0.1-10.8-0.1s4.8-0.1,10.8-0.1S637.5,215.8,637.5,215.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 624.4,
    y: 220.6,
    className: "st3",
    width: 3.7,
    height: 7.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M637.5,231.4c0,0.1-4.8,0.1-10.8,0.1s-10.8-0.1-10.8-0.1s4.8-0.1,10.8-0.1S637.5,231.3,637.5,231.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 624.4,
    y: 236.2,
    className: "st3",
    width: 3.7,
    height: 7.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M637.5,247c0,0.1-4.8,0.1-10.8,0.1s-10.8-0.1-10.8-0.1s4.8-0.1,10.8-0.1S637.5,246.9,637.5,247z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 624.4,
    y: 251.8,
    className: "st3",
    width: 3.7,
    height: 7.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M637.5,262.6c0,0.1-4.8,0.1-10.8,0.1s-10.8-0.1-10.8-0.1s4.8-0.1,10.8-0.1S637.5,262.5,637.5,262.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 624.4,
    y: 267.4,
    className: "st3",
    width: 3.7,
    height: 7.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M637.5,278.2c0,0.1-4.8,0.1-10.8,0.1s-10.8-0.1-10.8-0.1s4.8-0.1,10.8-0.1S637.5,278.1,637.5,278.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 624.4,
    y: 283,
    className: "st3",
    width: 3.7,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 618.3,
    y: 263.3,
    className: "st2",
    width: 63.2,
    height: 83.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 651.9,
    y: 263.3,
    className: "st0",
    width: 29.7,
    height: 83.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 631.6,
    y: 274.6,
    className: "st1",
    width: 5.7,
    height: 13.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 631.6,
    y: 328.7,
    className: "st1",
    width: 5.7,
    height: 13.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M651.9,293.9c0,0.2-7.5,0.3-16.8,0.3s-16.8-0.1-16.8-0.3s7.5-0.3,16.8-0.3S651.9,293.7,651.9,293.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 631.6,
    y: 301.9,
    className: "st1",
    width: 5.7,
    height: 13.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M651.9,321.1c0,0.2-7.5,0.3-16.8,0.3s-16.8-0.1-16.8-0.3s7.5-0.3,16.8-0.3S651.9,320.9,651.9,321.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 658.2,
    y: 274.6,
    className: "st1",
    width: 5.7,
    height: 13.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 670.5,
    y: 274.6,
    className: "st1",
    width: 5.7,
    height: 13.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 658.2,
    y: 300.8,
    className: "st1",
    width: 5.7,
    height: 13.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 670.5,
    y: 300.8,
    className: "st1",
    width: 5.7,
    height: 13.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 658.2,
    y: 327,
    className: "st1",
    width: 5.7,
    height: 13.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 670.5,
    y: 327,
    className: "st1",
    width: 5.7,
    height: 13.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 613.5,
    y: 260.4,
    className: "st0",
    width: 72.7,
    height: 3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M682,263.7c0,0.2-14.1,0.3-31.6,0.3s-31.6-0.1-31.6-0.3s14.1-0.3,31.6-0.3S682,263.6,682,263.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "615.4,347.4 551.7,347.4 551.4,246.6 615.2,246.6  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 583.3,
    y: 246.6,
    className: "st0",
    width: 31.9,
    height: 100.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 558.7,
    y: 226.8,
    className: "st2",
    width: 22.5,
    height: 19.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 575.8,
    y: 226.8,
    className: "st0",
    width: 5.4,
    height: 19.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 546.1,
    y: 245.5,
    className: "st0",
    width: 70.9,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 564,
    y: 255.3,
    className: "st4",
    width: 5.4,
    height: 11.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M583.3,271.1c0,0.1-7.1,0.2-15.9,0.2s-15.9-0.1-15.9-0.2s7.1-0.2,15.9-0.2S583.3,271,583.3,271.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 596.1,
    y: 255.3,
    className: "st1",
    width: 5.4,
    height: 11.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M615.4,271.1c0,0.1-7.1,0.2-15.9,0.2s-15.9-0.1-15.9-0.2s7.1-0.2,15.9-0.2S615.4,271,615.4,271.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 596.1,
    y: 277.9,
    className: "st1",
    width: 5.4,
    height: 11.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M615.4,293.7c0,0.1-7.1,0.2-15.9,0.2s-15.9-0.1-15.9-0.2s7.1-0.2,15.9-0.2S615.4,293.6,615.4,293.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 596.1,
    y: 301.1,
    className: "st1",
    width: 5.4,
    height: 11.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M615.4,317c0,0.1-7.1,0.2-15.9,0.2s-15.9-0.1-15.9-0.2s7.1-0.2,15.9-0.2S615.4,316.9,615.4,317z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 596.1,
    y: 324.4,
    className: "st1",
    width: 5.4,
    height: 11.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M615.4,340.3c0,0.1-7.1,0.2-15.9,0.2s-15.9-0.1-15.9-0.2s7.1-0.2,15.9-0.2S615.4,340.1,615.4,340.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 564,
    y: 278.2,
    className: "st4",
    width: 5.4,
    height: 11.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M583.3,294.1c0,0.1-7.1,0.2-15.9,0.2s-15.9-0.1-15.9-0.2s7.1-0.2,15.9-0.2S583.3,294,583.3,294.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 564,
    y: 301.2,
    className: "st4",
    width: 5.4,
    height: 11.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M583.3,317c0,0.1-7.1,0.2-15.9,0.2s-15.9-0.1-15.9-0.2s7.1-0.2,15.9-0.2S583.3,316.9,583.3,317z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 564,
    y: 324.1,
    className: "st4",
    width: 5.4,
    height: 11.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M583.3,339.9c0,0.1-7.1,0.2-15.9,0.2s-15.9-0.1-15.9-0.2s7.1-0.2,15.9-0.2S583.3,339.8,583.3,339.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 484.5,
    y: 160.5,
    className: "st2",
    width: 52.4,
    height: 185.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 488.7,
    y: 166.9,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 498.5,
    y: 166.9,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 508.3,
    y: 166.9,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 518.1,
    y: 166.9,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 527.9,
    y: 166.9,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 488.7,
    y: 180.7,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 498.5,
    y: 180.7,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 508.3,
    y: 180.7,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 518.1,
    y: 180.7,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 527.9,
    y: 180.7,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 488.7,
    y: 194.4,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 498.5,
    y: 194.4,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 508.3,
    y: 194.4,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 518.1,
    y: 194.4,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 527.9,
    y: 194.4,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 488.7,
    y: 208.2,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 498.5,
    y: 208.2,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 508.3,
    y: 208.2,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 518.1,
    y: 208.2,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 527.9,
    y: 208.2,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 488.7,
    y: 221.9,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 498.5,
    y: 221.9,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 508.3,
    y: 221.9,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 518.1,
    y: 221.9,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 527.9,
    y: 221.9,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 488.7,
    y: 235.7,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 498.5,
    y: 235.7,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 508.3,
    y: 235.7,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 518.1,
    y: 235.7,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 527.9,
    y: 235.7,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 488.7,
    y: 249.4,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 498.5,
    y: 249.4,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 508.3,
    y: 249.4,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 518.1,
    y: 249.4,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 527.9,
    y: 249.4,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 488.7,
    y: 263.2,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 498.5,
    y: 263.2,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 508.3,
    y: 263.2,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 518.1,
    y: 263.2,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 527.9,
    y: 263.2,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 488.7,
    y: 276.9,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 498.5,
    y: 276.9,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 508.3,
    y: 276.9,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 518.1,
    y: 276.9,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 527.9,
    y: 276.9,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 488.7,
    y: 290.7,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 498.5,
    y: 290.7,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 508.3,
    y: 290.7,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 518.1,
    y: 290.7,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 527.9,
    y: 290.7,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 488.7,
    y: 304.4,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 498.5,
    y: 304.4,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 508.3,
    y: 304.4,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 518.1,
    y: 304.4,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 527.9,
    y: 304.4,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 488.7,
    y: 318.1,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 498.5,
    y: 318.1,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 508.3,
    y: 318.1,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 518.1,
    y: 318.1,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 527.9,
    y: 318.1,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 488.7,
    y: 331.1,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 498.5,
    y: 331.1,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 508.3,
    y: 331.1,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 518.1,
    y: 331.1,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 527.9,
    y: 331.1,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 536.8,
    y: 160.5,
    className: "st0",
    width: 22.9,
    height: 185.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 508.3,
    y: 166.9,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 518.1,
    y: 166.9,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 527.9,
    y: 166.9,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 508.3,
    y: 180.7,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 518.1,
    y: 180.7,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 527.9,
    y: 180.7,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 508.3,
    y: 194.4,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 518.1,
    y: 194.4,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 527.9,
    y: 194.4,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 508.3,
    y: 208.2,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 518.1,
    y: 208.2,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 527.9,
    y: 208.2,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 508.3,
    y: 221.9,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 518.1,
    y: 221.9,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 527.9,
    y: 221.9,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 508.3,
    y: 235.7,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 518.1,
    y: 235.7,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 527.9,
    y: 235.7,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 508.3,
    y: 249.4,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 518.1,
    y: 249.4,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 527.9,
    y: 249.4,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 508.3,
    y: 263.2,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 518.1,
    y: 263.2,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 527.9,
    y: 263.2,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 508.3,
    y: 276.9,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 518.1,
    y: 276.9,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 527.9,
    y: 276.9,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 508.3,
    y: 290.7,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 518.1,
    y: 290.7,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 527.9,
    y: 290.7,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 508.3,
    y: 304.4,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 518.1,
    y: 304.4,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 527.9,
    y: 304.4,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 508.3,
    y: 318.1,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 518.1,
    y: 318.1,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 527.9,
    y: 318.1,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 508.3,
    y: 331.1,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 518.1,
    y: 331.1,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 527.9,
    y: 331.1,
    className: "st4",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 542,
    y: 166.9,
    className: "st2",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 551.8,
    y: 166.9,
    className: "st2",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 542,
    y: 180.7,
    className: "st2",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 551.8,
    y: 180.7,
    className: "st2",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 542,
    y: 194.4,
    className: "st2",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 551.8,
    y: 194.4,
    className: "st2",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 542,
    y: 208.2,
    className: "st2",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 551.8,
    y: 208.2,
    className: "st2",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 542,
    y: 221.9,
    className: "st2",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 551.8,
    y: 221.9,
    className: "st2",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 542,
    y: 235.7,
    className: "st2",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 551.8,
    y: 235.7,
    className: "st2",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 542,
    y: 249.4,
    className: "st2",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 551.8,
    y: 249.4,
    className: "st2",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 542,
    y: 263.2,
    className: "st2",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 551.8,
    y: 263.2,
    className: "st2",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 542,
    y: 276.9,
    className: "st2",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 551.8,
    y: 276.9,
    className: "st2",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 542,
    y: 290.7,
    className: "st2",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 551.8,
    y: 290.7,
    className: "st2",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 542,
    y: 304.4,
    className: "st2",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 551.8,
    y: 304.4,
    className: "st2",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 542,
    y: 318.1,
    className: "st2",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 551.8,
    y: 318.1,
    className: "st2",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 542,
    y: 331.1,
    className: "st2",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 551.8,
    y: 331.1,
    className: "st2",
    width: 4.7,
    height: 9.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M603.1,205.1c0.2,0,0.4,4.4,0.4,9.8s-0.2,9.8-0.4,9.8s-0.4-4.4-0.4-9.8S602.9,205.1,603.1,205.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "622.7,226.3 567.8,241.9 567.8,347.4 622.7,347.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "576,239.5 576,220.7 609.8,220.7 609.8,229.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "572,242.9 572.4,339.9 617.1,339.9 617.1,230.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M584.1,342.1c-0.2,0-0.4-23.3-0.4-52s0.2-52,0.4-52s0.4,23.3,0.4,52S584.3,342.1,584.1,342.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M602.8,342.1c-0.2,0-0.4-24.6-0.4-54.9s0.2-54.9,0.4-54.9s0.4,24.6,0.4,54.9S603,342.1,602.8,342.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M620.2,257.7c0,0.2-11.1,0.4-24.8,0.4s-24.8-0.2-24.8-0.4s11.1-0.4,24.8-0.4S620.2,257.5,620.2,257.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M619.7,287.4c0,0.2-11.1,0.4-24.8,0.4s-24.8-0.2-24.8-0.4s11.1-0.4,24.8-0.4S619.7,287.2,619.7,287.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M622.5,317.3c0,0.2-11.5,0.4-25.8,0.4s-25.8-0.2-25.8-0.4s11.5-0.4,25.8-0.4S622.5,317.1,622.5,317.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M622.5,226.3c0.1,0.2-12.1,3.8-27.1,8.1s-27.3,7.6-27.3,7.4s12.1-3.8,27.1-8.1S622.4,226.1,622.5,226.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M586.6,279.9c-0.2-0.1,2.5-3.1,6-6.6s6.4-6.2,6.6-6s-2.5,3.1-6,6.6S586.7,280,586.6,279.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M595,268c0.1,0.1-0.8,1.3-2.2,2.6s-2.6,2.2-2.7,2s0.8-1.3,2.2-2.6S594.8,267.8,595,268z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M598.1,301.5c0.2,0.1-2.2,2.7-5.2,5.8s-5.5,5.4-5.7,5.2s2.2-2.7,5.2-5.8S597.9,301.4,598.1,301.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M593.8,302.9c0.2,0.1-0.6,1.2-1.7,2.5s-2.1,2.1-2.3,2s0.6-1.2,1.7-2.5S593.7,302.7,593.8,302.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M612.8,242.9c0.2,0.1-1,1.8-2.5,3.6s-3,3.2-3.2,3.1s1-1.7,2.6-3.6S612.6,242.8,612.8,242.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M611.5,241c0.2,0.1-0.7,1.3-1.8,2.6s-2.2,2.2-2.4,2.1s0.7-1.3,1.8-2.6S611.4,240.8,611.5,241z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M580,327.9c0.2,0.1-0.5,1.4-1.6,2.9s-2,2.5-2.2,2.4s0.5-1.4,1.6-2.9S579.8,327.7,580,327.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M578.6,326.1c0.2,0.1-0.5,1-1.4,2s-1.8,1.6-1.9,1.5s0.5-1,1.4-2S578.5,325.9,578.6,326.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M532.5,103.3c0.6-4-5.1-7.4-9.4-7.7c-2-0.2-4.2,0.2-6.1-0.5c-4.2-1.5-5.9-6.9-9.9-8.6c-3-1.3-6.6-0.1-9.5,1.3 s-5.9,3.4-9.2,3.6c-2.9,0.2-6-0.9-8.5,0.5c-1.9,1-2.9,3.2-4.6,4.5c-1.8,1.1-3.9,1.7-6,1.6c-2.1-0.1-4.2,0.3-6.2,1 c-1.9,0.9-3.5,2.9-3.1,5L532.5,103.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M118.3,83.9h13.8c1.5,0.1,2.6,1.3,2.6,2.7l0.5,11.9c0.1,1.5-1,2.9-2.5,3c0,0,0,0,0,0l-14.3,0.2L118.3,83.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M148.9,98.6c2.7,0.3,77.8-12,84.7-13.8c7.7-2,8.2-7.9,8.2-7.9l-113.2,10l-0.5,6.7l13.4-1.1 C141.5,92.5,146.1,98.3,148.9,98.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M233.6,84.8c1.1-0.3,2.1-0.6,3.1-1l-4.8,0.4l-90.3,8.3c0,0,4.6,5.9,7.4,6.1S226.7,86.6,233.6,84.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M131.7,93.2c0-0.2,10.3-1.2,23-2.4s23-1.9,23.1-1.7s-10.3,1.2-23,2.4S131.7,93.4,131.7,93.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "103.8,101.7 97.3,347.1 123.8,347.1 115.7,101.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "103.8,101.7 103.4,125.4 116.4,113.7 115.7,101.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88.6,87.3v12.3c0,1.1,0.9,2,2,2h27.7V83.9l-27.7,1.4C89.5,85.3,88.6,86.3,88.6,87.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M115.9,73.7c-2.1-1.8-70.5-35-77.1-37.6c-7.5-2.8-11.2,1.7-11.2,1.7L125.7,95l4.2-5.2L118.3,83 C118.3,83,118,75.5,115.9,73.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M38.8,36.1c-1-0.4-2.1-0.7-3.1-0.9l4.2,2.5l78.6,45.3c0,0-0.4-7.4-2.5-9.2S45.4,38.6,38.8,36.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89.2,66.1c0.6,0.2,1.1,0.5,1.6,0.8l4.2,2.4l14,8c5.5,3.1,10.4,6,14,8.1c1.8,1.1,3.2,2,4.1,2.6 c0.5,0.3,1,0.6,1.5,1c-0.6-0.2-1.1-0.5-1.6-0.8c-1.1-0.6-2.5-1.4-4.2-2.4l-14.1-8c-5.5-3.1-10.4-6-13.9-8.1c-1.8-1.1-3.2-2-4.1-2.6 C90.1,66.8,89.6,66.5,89.2,66.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "101.6,185.5 118.5,185.5 118.8,197.1 101.5,197.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "101.3,200.4 118.8,200.5 119.1,203.4 101.3,203.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M124.8,115.9c0.5,2.7,33.5,71.2,37.2,77.3c4.1,6.9,9.9,5.6,9.9,5.6L130.3,93.1l-6.5,1.4l4.8,12.6 C128.6,107.1,124.3,113.2,124.8,115.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M162,193.2c0.6,0.9,1.2,1.8,1.9,2.7l-1.7-4.5l-33.5-84.3c0,0-4.3,6.1-3.8,8.8S158.3,187.1,162,193.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M123.6,94c0.3,0.5,0.6,1,0.8,1.6c0.5,1.2,1.1,2.6,1.9,4.4c1.6,3.7,3.7,8.9,6,14.6s4.2,10.9,5.6,14.7 c0.7,1.9,1.2,3.4,1.6,4.5c0.2,0.6,0.4,1.1,0.5,1.7c-0.3-0.5-0.5-1.1-0.7-1.6c-0.5-1.2-1.1-2.7-1.7-4.4l-5.8-14.7 c-2.2-5.7-4.2-10.8-5.8-14.7c-0.7-1.8-1.2-3.3-1.7-4.5C123.9,95.1,123.7,94.6,123.6,94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M131.4,91.4c0,1.3,1.1,3.8,0.3,4.6s-3.3,0.5-4.6,0.5c-2.4,0-4.3-2.3-4.3-5.1s1.9-5.1,4.3-5.1 c1.6-0.2,3.2,0,4.8,0.4C133,87,131.4,90.1,131.4,91.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M134.6,91.4c0,2.8-1.9,5.1-4.3,5.1s-4.3-2.3-4.3-5.1s1.9-5.1,4.3-5.1S134.6,88.6,134.6,91.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M126.2,86.3c0.5-0.1,1.1-0.2,1.6-0.2l1.8-0.1c0.3,0,0.7-0.1,1.1,0c0.4,0,0.9,0.2,1.3,0.4l0,0h0.1 c1.7,0.9,2.8,2.6,2.9,4.5c0.1,1.6-0.4,3.3-1.5,4.5c-0.9,1-2.2,1.5-3.5,1.3l0,0c-1,0-1.9,0-2.9-0.2c0.9-0.2,1.9-0.3,2.8-0.3l0,0 c1.1,0.1,2.3-0.4,3-1.3c1-1.1,1.4-2.5,1.3-4c-0.1-1.7-1-3.2-2.5-4l0,0c-0.3-0.2-0.7-0.3-1.1-0.3c-0.4-0.1-0.7,0-1.1,0l-1.8-0.1 C127.2,86.5,126.7,86.4,126.2,86.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M129.9,96.4c0,0.1-0.8,0-1.8-0.7c-2.5-1.7-3.2-5.1-1.5-7.7c0.1-0.2,0.3-0.4,0.4-0.6c0.8-0.9,1.5-1.2,1.5-1.1 s-0.5,0.5-1.2,1.4c-0.8,1.2-1.2,2.6-1,4c0.2,1.4,0.9,2.7,2,3.6C129.3,96.1,130,96.3,129.9,96.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M128,96.5c-0.7,0.1-1.4,0.1-2-0.2c-2.8-1-4.3-4.2-3.2-7c0.2-0.5,0.5-1,0.8-1.5c0.8-1,1.6-1.3,1.6-1.3 s-0.6,0.5-1.2,1.5c-1.6,2.4-1,5.7,1.4,7.4c0.2,0.2,0.5,0.3,0.8,0.4C127.3,96.4,128.1,96.4,128,96.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M257.6,146.5h8.4c0.9,0,1.6,0.8,1.6,1.7l0.3,7.2c0.1,0.9-0.6,1.8-1.5,1.8c0,0,0,0,0,0l-8.7,0.1L257.6,146.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M260.1,164.6c-0.1,1.7,9.3,46.9,10.6,51.1c1.4,4.7,5,4.8,5,4.8l-9-68.5l-4-0.1l1,8.1 C263.6,160,260.2,163,260.1,164.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M270.7,215.7c0.2,0.6,0.4,1.2,0.7,1.9l-0.4-2.9l-7.4-54.7c0,0-3.4,2.9-3.5,4.6S269.5,211.6,270.7,215.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M262.9,154.1c0.2,0,1.1,6.2,2.2,13.9s1.7,13.9,1.5,14s-1.1-6.2-2.2-13.9S262.8,154.1,262.9,154.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "248.8,157.3 248.8,337 265.9,337.1 256,157.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "248.8,157.3 248.5,171.7 256.5,164.6 256,157.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M239.6,148.6v7.5c0,0.7,0.6,1.2,1.2,1.2h16.8v-10.9l-16.9,0.9C240.1,147.4,239.6,147.9,239.6,148.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M274.4,144c1-1.3,19.5-43.7,20.8-47.8c1.5-4.6-1.3-6.8-1.3-6.8l-32.2,61.1l3.2,2.4l3.9-7.2 C268.8,145.7,273.4,145.3,274.4,144z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M295.2,96.1c0.2-0.6,0.4-1.3,0.5-1.9l-1.4,2.6l-25.5,48.9c0,0,4.5-0.4,5.5-1.7S293.8,100.2,295.2,96.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M278.3,127.5c-0.5,1.3-1.1,2.5-1.8,3.7c-1.2,2.4-2.8,5.4-4.5,8.8s-3.4,6.5-4.6,8.7c-0.6,1.2-1.3,2.4-2.2,3.5 c0.5-1.3,1.1-2.5,1.8-3.7c1.2-2.4,2.8-5.4,4.5-8.8s3.4-6.5,4.6-8.7C276.8,129.8,277.5,128.6,278.3,127.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "248,208.1 259,208.1 259.4,214.9 247.9,214.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "247.8,217.3 259.6,217.3 259.7,219.1 247.8,219.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M249,150.5c-1.6,0.4-42.4,22.2-46,24.6c-4.1,2.7-3.2,6.1-3.2,6.1l63.2-28l-1-3.9l-7.5,3.3 C254.5,152.6,250.6,150.1,249,150.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M203,175.1c-0.5,0.4-1.1,0.8-1.6,1.2l2.7-1.1l50.3-22.5c0,0-3.8-2.5-5.4-2.1S206.6,172.7,203,175.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M262.3,149.2c-1.1,0.7-2.3,1.3-3.5,1.9c-2.2,1.1-5.3,2.5-8.7,4s-6.5,2.9-8.8,3.8c-1.2,0.6-2.5,1-3.8,1.3 c1.1-0.7,2.3-1.2,3.6-1.7l8.7-3.9c3.4-1.5,6.5-2.9,8.8-3.9C259.8,150,261,149.5,262.3,149.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M265.6,151c0,0.8,0.6,2.3,0.2,2.8s-2,0.3-2.8,0.3c-1.7-0.3-2.9-2-2.6-3.7c0.2-1.3,1.3-2.3,2.6-2.6 c1-0.1,2,0,2.9,0.2C266.5,148.4,265.6,150.3,265.6,151z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M267.5,151c-0.2,1.5-1.6,2.4-3.1,2.2c-1.5-0.2-2.4-1.6-2.2-3.1c0.2-1.3,1.3-2.2,2.6-2.2 C266.5,148,267.7,149.4,267.5,151z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M262.4,147.9c0-0.1,0.4-0.1,1-0.2l1.1-0.1c0.2,0,0.4-0.1,0.7,0c0.3,0,0.6,0.1,0.8,0.2l0,0h0 c1.1,0.6,1.8,1.6,1.8,2.8c0.1,1-0.3,2-1,2.8c-0.6,0.6-1.4,0.9-2.2,0.8l0,0c-0.6,0-1.2,0-1.8-0.2c0.6-0.2,1.1-0.3,1.7-0.2l0,0 c0.7,0,1.3-0.3,1.7-0.8c0.6-0.7,0.8-1.5,0.7-2.4c0-1-0.6-1.9-1.4-2.4l0,0l0,0l0,0c-0.4-0.2-0.8-0.3-1.3-0.2l-1.1-0.1 C262.8,148,262.4,148,262.4,147.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M264.7,154.1c0,0.1-0.5,0.1-1.1-0.3c-1.6-1-2-3.1-1-4.6c0.1-0.2,0.2-0.3,0.4-0.5c0.5-0.6,1-0.7,1-0.6 s-0.3,0.3-0.6,0.9c-1,1.4-0.7,3.4,0.6,4.5C264.3,153.8,264.7,154,264.7,154.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M263.5,154.2c0,0.1-0.5,0.2-1.3-0.1c-1.7-0.6-2.7-2.5-2.1-4.2c0.1-0.4,0.3-0.7,0.6-1c0.5-0.6,1-0.8,1-0.7 s-0.3,0.4-0.7,1c-0.5,0.8-0.6,1.7-0.4,2.6c0.3,0.9,0.9,1.6,1.7,2C263.1,154,263.5,154.1,263.5,154.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M627.4,142.4c0,0-0.3-0.1-1-0.2c-0.9-0.2-1.8-0.2-2.7-0.1c-1.3,0.2-2.6,0.7-3.6,1.6c-1.3,1-2.2,2.5-2.5,4.1 l0,0l-0.2,0.6l-0.2-0.6c-0.6-1.5-1.7-2.8-3.1-3.7c-1.1-0.7-2.4-1.2-3.8-1.3c-1.2-0.1-2.5,0.1-3.7,0.5c0.3-0.2,0.6-0.3,0.9-0.4 c2.3-0.7,4.7-0.4,6.7,0.9c1.5,0.9,2.6,2.3,3.2,3.9h-0.4v-0.1c0.4-1.7,1.4-3.2,2.7-4.3c1.1-0.9,2.4-1.4,3.8-1.6 c0.9-0.1,1.9,0,2.8,0.2C626.8,142,627.1,142.2,627.4,142.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58,117.3c0,0-0.3-0.1-1-0.2c-0.9-0.2-1.8-0.2-2.7-0.1c-1.3,0.2-2.6,0.7-3.6,1.6c-1.3,1-2.2,2.5-2.6,4.1l0,0 l-0.2,0.6l-0.2-0.6c-0.6-1.5-1.7-2.8-3-3.7c-1.1-0.7-2.4-1.2-3.7-1.3c-1.2-0.1-2.5,0.1-3.7,0.5c0.3-0.2,0.6-0.3,0.9-0.4 c2.3-0.7,4.7-0.4,6.7,0.9c1.5,0.9,2.6,2.3,3.2,3.9h-0.4l0,0c0.4-1.7,1.4-3.2,2.7-4.3c1.1-0.9,2.4-1.4,3.8-1.6 c0.9-0.1,1.9,0,2.8,0.2C57.4,117,57.7,117.1,58,117.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M279.2,55.5c0,0-0.4-0.1-1-0.2c-0.9-0.2-1.8-0.2-2.7-0.1c-1.3,0.2-2.6,0.7-3.6,1.6c-1.3,1-2.2,2.5-2.6,4.1l0,0 l-0.1,0.6l-0.2-0.6c-0.6-1.5-1.7-2.8-3.1-3.7c-1.1-0.7-2.4-1.1-3.8-1.2c-1.2-0.1-2.5,0.1-3.7,0.5c0.3-0.2,0.6-0.3,0.9-0.4 c0.9-0.3,1.8-0.4,2.8-0.3c1.4,0.1,2.8,0.5,3.9,1.2c1.5,0.9,2.6,2.3,3.2,3.9h-0.4v0c0.4-1.7,1.4-3.2,2.7-4.3 c1.1-0.9,2.4-1.4,3.8-1.6c0.9-0.1,1.9,0,2.8,0.2C278.6,55.2,278.9,55.3,279.2,55.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M231,118.4c0,0-0.4-0.1-1-0.2c-0.9-0.2-1.8-0.2-2.7-0.1c-1.3,0.2-2.6,0.7-3.6,1.6c-1.3,1-2.2,2.5-2.6,4.1l0,0 l-0.1,0.6l-0.2-0.6c-0.6-1.5-1.7-2.8-3.1-3.7c-1.1-0.7-2.4-1.2-3.8-1.3c-1.2-0.1-2.5,0.1-3.7,0.5c0.3-0.2,0.6-0.3,0.9-0.4 c2.3-0.7,4.7-0.4,6.7,0.9c1.5,0.9,2.6,2.3,3.2,3.9h-0.4l0,0c0.4-1.7,1.4-3.2,2.7-4.3c1.1-0.9,2.4-1.4,3.8-1.6 c0.9-0.1,1.9,0,2.8,0.2C230.4,118.1,230.7,118.3,231,118.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M611,52.2c-0.3-0.1-0.7-0.1-1-0.2c-0.9-0.2-1.8-0.2-2.7-0.1c-1.3,0.2-2.6,0.7-3.6,1.6c-1.3,1-2.2,2.5-2.6,4.1 l0,0l-0.2,0.6l-0.2-0.6c-0.6-1.5-1.7-2.8-3.1-3.7c-1.1-0.7-2.4-1.2-3.8-1.3c-1.2-0.1-2.5,0.1-3.7,0.5c0.3-0.2,0.6-0.3,0.9-0.4 c0.9-0.3,1.8-0.4,2.8-0.3c1.4,0.1,2.8,0.5,3.9,1.2c1.5,0.9,2.6,2.3,3.2,3.9h-0.4v0c0.4-1.7,1.4-3.2,2.7-4.3 c1.1-0.9,2.4-1.4,3.8-1.6c0.9-0.1,1.9,0,2.8,0.2C610.4,51.8,610.7,52,611,52.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M216.8,54.2c0.5-3.8-4.9-7-8.9-7.3c-1.9-0.2-3.9,0.1-5.8-0.5c-4-1.4-5.6-6.5-9.4-8.1c-2.9-1.2-6.2-0.1-9,1.3 s-5.6,3.2-8.7,3.4c-2.7,0.2-5.7-0.8-8.1,0.5c-1.8,1-2.7,3-4.4,4.2c-1.7,1.1-3.7,1.6-5.7,1.5c-2,0-4,0.3-5.9,1 c-1.8,0.8-3.3,2.8-2.9,4.7L216.8,54.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M415.6,175.5c0.5-3.6-4.6-6.6-8.5-7c-1.8-0.1-3.8,0.1-5.5-0.5c-3.8-1.3-5.3-6.2-9-7.8 c-2.8-1.2-5.9-0.1-8.6,1.2s-5.3,3-8.3,3.2c-2.6,0.2-5.4-0.8-7.7,0.5c-1.7,1-2.6,2.9-4.1,4.1c-1.6,1-3.5,1.5-5.4,1.5 c-1.9,0-3.8,0.3-5.6,0.9c-1.7,0.8-3.2,2.6-2.8,4.5L415.6,175.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M714.1,120.1c0.4-3.2-4-5.8-7.4-6c-1.6-0.1-3.3,0.1-4.8-0.4c-3.3-1.2-4.6-5.4-7.8-6.8c-2.4-1-5.2-0.1-7.5,1.1 s-4.6,2.7-7.2,2.8c-2.3,0.2-4.7-0.7-6.7,0.4c-1.5,0.8-2.2,2.5-3.6,3.5c-1.4,0.9-3.1,1.3-4.7,1.3c-1.7,0-3.3,0.2-4.9,0.8 c-1.6,0.6-2.6,2.2-2.4,3.9L714.1,120.1z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M726.7,476.5c0,0.1-157.5,0.3-351.7,0.3s-351.7-0.1-351.7-0.3s157.4-0.3,351.7-0.3S726.7,476.3,726.7,476.5z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Birds--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M562.9,59.7c0,0-0.7-0.2-2-0.5c-1.9-0.4-3.8-0.5-5.7-0.2c-2.8,0.4-5.4,1.5-7.6,3.3c-2.7,2.2-4.6,5.2-5.4,8.6 v0.1l-0.2,0.6l-0.2-0.6c-1.3-3.2-3.6-5.9-6.5-7.8c-2.4-1.5-5.1-2.4-7.9-2.6c-1.9-0.1-3.8,0-5.6,0.5c-1.3,0.3-2,0.7-2,0.6 c0.2-0.1,0.3-0.2,0.5-0.2c0.5-0.2,1-0.4,1.5-0.5c4.7-1.3,9.7-0.6,13.8,2c3,1.9,5.3,4.7,6.6,8h-0.4v-0.1c0.8-3.5,2.8-6.5,5.6-8.8 c2.2-1.8,5-3,7.8-3.3c1.9-0.2,3.9-0.1,5.7,0.3c0.5,0.1,1,0.3,1.5,0.5C562.6,59.5,562.7,59.6,562.9,59.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M657.9,85.8c0,0-0.4-0.1-1.1-0.3c-1-0.2-2.1-0.2-3.1-0.1c-1.5,0.2-3,0.8-4.2,1.8c-1.5,1.2-2.5,2.8-2.9,4.7l0,0 l-0.2,0.6l-0.2-0.6c-0.7-1.7-1.9-3.2-3.5-4.3c-1.3-0.8-2.8-1.3-4.3-1.4c-1-0.1-2.1,0-3.1,0.3c-0.7,0.2-1.1,0.3-1.1,0.3 c0.1-0.1,0.2-0.1,0.3-0.1c0.3-0.1,0.5-0.2,0.8-0.3c1-0.3,2.1-0.4,3.1-0.4c1.6,0.1,3.1,0.6,4.5,1.4c1.7,1.1,2.9,2.6,3.7,4.4h-0.4 l0,0c0.5-1.9,1.6-3.6,3.1-4.9c1.3-1,2.8-1.6,4.3-1.8c1.1-0.1,2.1-0.1,3.2,0.2c0.3,0.1,0.6,0.2,0.8,0.3 C657.8,85.7,657.9,85.8,657.9,85.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M603.7,90c0,0-0.4,0.4-1.1,1.2c-1,1.1-1.8,2.3-2.6,3.6c-2.6,4.1-3.9,8.9-3.9,13.8v0.2h-0.4 c-0.4-2.6-1.2-5.1-2.5-7.5c-1.7-3.2-4.2-5.9-7.2-8c-0.5-0.3-0.9-0.6-1.3-0.9c0.1,0,0.3,0.1,0.4,0.2c0.2,0.1,0.6,0.3,1,0.6 c1.2,0.8,2.4,1.7,3.4,2.8c3.5,3.4,5.8,7.9,6.6,12.8h-0.4v-0.2c0-4.9,1.4-9.8,4.1-13.9c0.8-1.2,1.7-2.4,2.8-3.5 c0.4-0.4,0.7-0.7,0.9-0.8C603.4,90.1,603.5,90.1,603.7,90z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--solar-panels--inject-16"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "379.5,356.6 364.2,476.5 374.7,476.5 390.3,365.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "364.2,335.9 360.9,346.1 428.3,476.5 657.6,476.1 663.2,466.7 558.4,422.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "364.2,335.9 432.4,468.4 663.2,466.7 590.5,335.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M364.2,335.9l226.4-0.2h0.1l0.1,0.1l72.7,130.8l0.2,0.4h-2.4l-228.9,1.7h-0.1l-0.1-0.1L364.2,335.9 c0.8,1.5,26.7,51.7,68.4,132.5l-0.2-0.1l228.9-1.8h1.9l-0.2,0.4L590.3,336l0.2,0.1L364.2,335.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M392.2,351.9H380c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h12 c0.9,0,1.7,0.5,2.2,1.2l5.4,9.4c0.2,0.4,0,0.8-0.4,0.9C392.4,351.9,392.3,351.9,392.2,351.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M410.4,351.9h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h12 c0.9,0,1.7,0.5,2.2,1.2l5.3,9.4c0.2,0.3,0.1,0.8-0.3,1C410.6,351.9,410.5,351.9,410.4,351.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M427.9,351.9h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1H421 c0.9,0,1.7,0.5,2.2,1.2l5.4,9.4c0.2,0.4,0,0.8-0.4,0.9C428.1,351.9,428,351.9,427.9,351.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M445.3,351.9h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h12 c0.9,0,1.7,0.5,2.2,1.2l5.4,9.4c0.2,0.4,0,0.8-0.4,0.9C445.5,351.9,445.4,351.9,445.3,351.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M399.1,366.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h12 c0.9,0,1.7,0.5,2.2,1.2l5.4,9.4c0.2,0.3,0,0.8-0.4,0.9C399.2,366.1,399.2,366.1,399.1,366.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M416.9,366.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1H410 c0.9,0,1.7,0.5,2.2,1.2l5.4,9.4c0.2,0.3,0,0.8-0.3,0.9C417.1,366.1,417,366.1,416.9,366.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M434.9,366.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1H428 c0.9,0,1.7,0.5,2.2,1.2l5.4,9.4c0.2,0.3,0,0.8-0.3,0.9C435.1,366.1,435,366.1,434.9,366.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M452.5,366.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.2l5.4,9.4c0.2,0.3,0,0.8-0.3,0.9C452.7,366.1,452.6,366.1,452.5,366.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M406.6,380.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.1,0.4,0,0.8-0.4,0.9C406.8,380.1,406.7,380.1,406.6,380.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M424.5,380.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.2,0.3,0,0.8-0.3,0.9C424.7,380.1,424.6,380.1,424.5,380.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M442.5,380.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h12 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.1,0.4,0,0.8-0.4,0.9C442.7,380.1,442.6,380.1,442.5,380.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M460.1,380.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.2,0.3,0,0.8-0.3,0.9C460.3,380.1,460.2,380.1,460.1,380.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M414.2,394.1H402c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.2,0.3,0,0.8-0.4,0.9C414.4,394.1,414.3,394.1,414.2,394.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M432.1,394.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.1,0.4,0,0.8-0.4,0.9C432.2,394.1,432.1,394.1,432.1,394.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M450.1,394.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.1,0.4,0,0.8-0.4,0.9C450.2,394.1,450.1,394.1,450.1,394.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M467.6,394.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.1,0.4,0,0.8-0.4,0.9C467.8,394.1,467.7,394.1,467.6,394.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M421.8,408.2h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.1,0.4,0,0.8-0.4,0.9C421.9,408.1,421.8,408.2,421.8,408.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M439.6,408.2h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h12 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.1,0.4,0,0.8-0.4,0.9C439.8,408.1,439.7,408.2,439.6,408.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M457.6,408.2h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.2,0.3,0,0.8-0.3,0.9C457.8,408.1,457.7,408.2,457.6,408.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M475.2,408.2H463c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h12 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.1,0.4,0,0.8-0.4,0.9C475.4,408.1,475.3,408.2,475.2,408.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M429.3,422.2h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.6c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h12 c0.9,0,1.7,0.5,2.2,1.2l5.4,9.4c0.1,0.4,0,0.8-0.4,0.9C429.5,422.1,429.4,422.2,429.3,422.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M447.2,422.2H435c-0.7,0-1.4-0.4-1.8-1l-5.5-9.6c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.2l5.4,9.4c0.1,0.4,0,0.8-0.4,0.9C447.4,422.1,447.3,422.2,447.2,422.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M465.2,422.2H453c-0.7,0-1.4-0.4-1.8-1l-5.5-9.6c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.2l5.4,9.4c0.1,0.4,0,0.8-0.4,0.9C465.4,422.1,465.3,422.2,465.2,422.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M482.8,422.2h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.6c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.4,2.1,1.2l5.4,9.4c0.2,0.3,0.1,0.8-0.3,0.9C483,422.1,482.9,422.2,482.8,422.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M436.9,436.2h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h12 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.1,0.4,0,0.8-0.4,0.9C437.1,436.2,437,436.2,436.9,436.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M454.8,436.2h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.2,0.3,0,0.8-0.3,0.9C454.9,436.2,454.8,436.2,454.8,436.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M472.8,436.2h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.1,0.4,0,0.8-0.4,0.9C472.9,436.2,472.8,436.2,472.8,436.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M490.3,436.2h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.2,0.3,0,0.8-0.3,0.9C490.5,436.2,490.4,436.2,490.3,436.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M444.5,450.2h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.2,0.3,0,0.8-0.3,0.9C444.7,450.2,444.6,450.2,444.5,450.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M462.3,450.2h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.2,0.3,0,0.8-0.3,0.9C462.5,450.2,462.4,450.2,462.3,450.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M480.3,450.2h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.1,0.4,0,0.8-0.4,0.9C480.5,450.2,480.4,450.2,480.3,450.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M497.9,450.2h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1H491 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.1,0.4,0,0.8-0.4,0.9C498.1,450.2,498,450.2,497.9,450.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M452,464.2h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.2,0.3,0,0.8-0.4,0.9C452.2,464.2,452.1,464.2,452,464.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M469.9,464.2h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h12 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.1,0.4,0,0.8-0.4,0.9C470.1,464.2,470,464.2,469.9,464.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M487.9,464.2h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h12 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.1,0.4,0,0.8-0.4,0.9C488.1,464.2,488,464.2,487.9,464.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M505.5,464.2h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h12 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.2,0.3,0,0.8-0.3,0.9C505.6,464.2,505.6,464.2,505.5,464.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M465.9,351.9h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h12 c0.9,0,1.7,0.5,2.2,1.2l5.4,9.4c0.2,0.4,0,0.8-0.4,0.9C466.1,351.9,466,351.9,465.9,351.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M484.1,351.9h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.2l5.4,9.4c0.2,0.4,0,0.8-0.4,0.9C484.3,351.9,484.2,351.9,484.1,351.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M501.6,351.9h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h12 c0.9,0,1.7,0.5,2.2,1.2l5.4,9.4c0.2,0.4,0,0.8-0.4,0.9C501.8,351.9,501.7,351.9,501.6,351.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M519,351.9h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.2l5.3,9.4c0.2,0.4,0,0.8-0.4,0.9C519.2,351.9,519.1,351.9,519,351.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M472.8,366.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h12 c0.9,0,1.7,0.5,2.2,1.2l5.4,9.4c0.2,0.3,0,0.8-0.4,0.9C473,366.1,472.9,366.1,472.8,366.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M490.6,366.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.2l5.4,9.4c0.2,0.3,0,0.8-0.3,0.9C490.8,366.1,490.7,366.1,490.6,366.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M508.6,366.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.2l5.4,9.4c0.2,0.3,0,0.8-0.4,0.9C508.8,366.1,508.7,366.1,508.6,366.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M526.2,366.1H514c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.2l5.3,9.4c0.2,0.3,0,0.8-0.3,0.9C526.4,366.1,526.3,366.1,526.2,366.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M480.4,380.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.1,0.4,0,0.8-0.4,0.9C480.5,380.1,480.4,380.1,480.4,380.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M498.2,380.1H486c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.2,0.3,0,0.8-0.3,0.9C498.4,380.1,498.3,380.1,498.2,380.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M516.2,380.1H504c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h12 c0.9,0,1.7,0.5,2.2,1.3l5.3,9.4c0.1,0.4,0,0.8-0.4,0.9C516.4,380.1,516.3,380.1,516.2,380.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M533.8,380.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.3,9.4c0.2,0.3,0,0.8-0.3,0.9C534,380.1,533.9,380.1,533.8,380.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M487.9,394.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1H481 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.2,0.3,0,0.8-0.3,0.9C488.1,394.1,488,394.1,487.9,394.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M505.8,394.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.1,0.4,0,0.8-0.4,0.9C505.9,394.1,505.9,394.1,505.8,394.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M523.8,394.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.3,9.4c0.1,0.4,0,0.8-0.4,0.9C523.9,394.1,523.9,394.1,523.8,394.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M541.4,394.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.2,0.3,0.1,0.8-0.3,1C541.6,394.1,541.5,394.1,541.4,394.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M495.5,408.2h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.2,0.3,0,0.8-0.3,0.9C495.6,408.1,495.6,408.2,495.5,408.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M513.3,408.2h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h12 c0.9,0,1.7,0.5,2.2,1.3l5.3,9.4c0.1,0.4,0,0.8-0.4,0.9C513.5,408.1,513.4,408.2,513.3,408.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M531.3,408.2h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.3,9.4c0.2,0.3,0,0.8-0.3,0.9C531.5,408.1,531.4,408.2,531.3,408.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M548.9,408.2h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1H542 c0.9,0,1.7,0.5,2.2,1.3l5.3,9.4c0.2,0.4,0,0.8-0.4,0.9C549.1,408.1,549,408.2,548.9,408.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M503,422.2h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.6c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h12 c0.9,0,1.7,0.5,2.2,1.2l5.4,9.4c0.1,0.4,0,0.8-0.4,0.9C503.2,422.1,503.1,422.2,503,422.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M520.9,422.2h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.6c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h12 c0.9,0,1.7,0.5,2.2,1.2l5.3,9.4c0.1,0.4,0,0.8-0.4,0.9C521.1,422.1,521,422.2,520.9,422.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M538.9,422.2h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.6c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h12 c0.9,0,1.7,0.5,2.2,1.2l5.4,9.4c0.1,0.4,0,0.8-0.4,0.9C539.1,422.1,539,422.2,538.9,422.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M556.5,422.2h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.2l5.3,9.4c0.2,0.3,0,0.8-0.3,0.9C556.7,422.1,556.6,422.2,556.5,422.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M510.6,436.2h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.1,0.4,0,0.8-0.4,0.9C510.8,436.2,510.7,436.2,510.6,436.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M528.5,436.2h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.3,9.4c0.2,0.3,0,0.8-0.3,0.9C528.7,436.2,528.6,436.2,528.5,436.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M546.5,436.2h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h12 c0.9,0,1.7,0.5,2.2,1.3l5.3,9.4c0.2,0.3,0,0.8-0.3,0.9C546.6,436.2,546.6,436.2,546.5,436.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M564,436.2h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.3,9.4c0.2,0.3,0,0.8-0.3,0.9C564.2,436.2,564.1,436.2,564,436.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M518.2,450.2H506c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.3,9.4c0.2,0.3,0,0.8-0.4,0.9C518.4,450.2,518.3,450.2,518.2,450.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M536,450.2h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.1,0.4,0,0.8-0.4,0.9C536.2,450.2,536.1,450.2,536,450.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M554,450.2h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.3,9.4c0.1,0.4,0,0.8-0.4,0.9C554.2,450.2,554.1,450.2,554,450.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M571.6,450.2h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.1,0.4,0,0.8-0.4,0.9C571.8,450.2,571.7,450.2,571.6,450.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M525.7,464.2h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.1,0.4,0,0.8-0.4,0.9C525.9,464.2,525.8,464.2,525.7,464.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M543.6,464.2h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h12 c0.9,0,1.7,0.5,2.2,1.3l5.3,9.4c0.1,0.4,0,0.8-0.4,0.9C543.7,464.2,543.7,464.2,543.6,464.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M561.6,464.2h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.3,9.4c0.2,0.3,0,0.8-0.3,0.9C561.8,464.2,561.7,464.2,561.6,464.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M579.2,464.2H567c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h12 c0.9,0,1.7,0.5,2.2,1.3l5.3,9.4c0.1,0.4,0,0.8-0.4,0.9C579.4,464.2,579.3,464.2,579.2,464.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M539.6,351.9h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.2l5.3,9.4c0.2,0.4,0,0.8-0.4,0.9C539.8,351.9,539.7,351.9,539.6,351.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M557.9,351.9h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h12 c0.9,0,1.7,0.5,2.2,1.2l5.3,9.4c0.2,0.4,0,0.8-0.4,0.9C558.1,351.9,558,351.9,557.9,351.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M575.3,351.9h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h12 c0.9,0,1.7,0.5,2.2,1.2l5.4,9.4c0.2,0.3,0.1,0.8-0.3,1C575.6,351.9,575.5,351.9,575.3,351.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M592.8,351.9h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.2l5.3,9.4c0.2,0.4,0,0.8-0.4,0.9C592.9,351.9,592.8,351.9,592.8,351.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M546.5,366.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.2l5.3,9.4c0.2,0.3,0,0.8-0.3,0.9C546.7,366.1,546.6,366.1,546.5,366.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M564.4,366.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.2l5.3,9.4c0.2,0.3,0,0.8-0.3,0.9C564.5,366.1,564.4,366.1,564.4,366.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M582.4,366.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.2l5.4,9.4c0.2,0.3,0,0.8-0.4,0.9C582.5,366.1,582.4,366.1,582.4,366.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M600,366.1h-12.3c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1H593 c0.9,0,1.7,0.5,2.2,1.2l5.3,9.4c0.2,0.3,0,0.8-0.3,0.9C600.1,366.1,600.1,366.1,600,366.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M554.1,380.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.3,9.4c0.2,0.3,0,0.8-0.3,0.9C554.2,380.1,554.1,380.1,554.1,380.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M571.9,380.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1H565 c0.9,0,1.7,0.5,2.2,1.3l5.3,9.4c0.2,0.3,0,0.8-0.3,0.9C572.1,380.1,572,380.1,571.9,380.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M589.9,380.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1H583 c0.9,0,1.7,0.5,2.2,1.3l5.3,9.4c0.2,0.4,0,0.8-0.4,0.9C590.1,380.1,590,380.1,589.9,380.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M607.5,380.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.1,0.4,0,0.8-0.4,0.9C607.7,380.1,607.6,380.1,607.5,380.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M561.6,394.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.3,9.4c0.2,0.3,0,0.8-0.3,0.9C561.8,394.1,561.7,394.1,561.6,394.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M579.5,394.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h12 c0.9,0,1.7,0.5,2.2,1.3l5.3,9.4c0.2,0.3,0,0.8-0.3,0.9C579.7,394.1,579.6,394.1,579.5,394.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M597.5,394.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.3,9.4c0.2,0.3,0,0.8-0.3,0.9C597.7,394.1,597.6,394.1,597.5,394.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M615.1,394.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h12 c0.9,0,1.7,0.5,2.2,1.3l5.3,9.4c0.1,0.4,0,0.8-0.4,0.9C615.2,394.1,615.2,394.1,615.1,394.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M569.2,408.2H557c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h12 c0.9,0,1.7,0.5,2.2,1.3l5.3,9.4c0.1,0.4,0,0.8-0.4,0.9C569.4,408.1,569.3,408.2,569.2,408.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M587,408.2h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.3,9.4c0.1,0.4,0,0.8-0.4,0.9C587.2,408.1,587.1,408.2,587,408.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M605,408.2h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.3,9.4c0.2,0.3,0,0.8-0.3,0.9C605.2,408.1,605.1,408.2,605,408.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M622.6,408.2h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.3,9.4c0.1,0.4,0,0.8-0.4,0.9C622.8,408.1,622.7,408.2,622.6,408.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M576.7,422.2h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.6c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.4,2.2,1.2l5.3,9.4c0.2,0.3,0.1,0.8-0.3,0.9C577,422.1,576.9,422.2,576.7,422.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M594.6,422.2h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.6c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.2l5.3,9.4c0.1,0.4,0,0.8-0.4,0.9C594.8,422.1,594.7,422.2,594.6,422.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M612.6,422.2h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.6c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.2l5.4,9.4c0.1,0.4,0,0.8-0.4,0.9C612.8,422.1,612.7,422.2,612.6,422.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M630.2,422.2H618c-0.7,0-1.4-0.4-1.8-1l-5.5-9.6c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.2l5.3,9.4c0.1,0.4,0,0.8-0.4,0.9C630.4,422.1,630.3,422.2,630.2,422.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M584.3,436.2h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.3,9.4c0.1,0.4,0,0.8-0.4,0.9C584.5,436.2,584.4,436.2,584.3,436.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M602.2,436.2H590c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.3,9.4c0.2,0.3,0,0.8-0.4,0.9C602.4,436.2,602.3,436.2,602.2,436.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M620.2,436.2H608c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h12 c0.9,0,1.7,0.5,2.2,1.3l5.3,9.4c0.1,0.4,0,0.8-0.4,0.9C620.4,436.2,620.3,436.2,620.2,436.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M637.8,436.2h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.1,0.4,0,0.8-0.4,0.9C637.9,436.2,637.8,436.2,637.8,436.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M591.9,450.2h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h12 c0.9,0,1.7,0.5,2.2,1.3l5.3,9.4c0.2,0.3,0,0.8-0.4,0.9C592.1,450.2,592,450.2,591.9,450.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M609.7,450.2h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.1,0.4,0,0.8-0.4,0.9C609.9,450.2,609.8,450.2,609.7,450.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M627.7,450.2h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.3,9.4c0.1,0.4,0,0.8-0.4,0.9C627.9,450.2,627.8,450.2,627.7,450.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M645.3,450.2h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h12 c0.9,0,1.7,0.5,2.2,1.3l5.3,9.4c0.1,0.4,0,0.8-0.4,0.9C645.5,450.2,645.4,450.2,645.3,450.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M599.4,464.2h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.2,0.3,0,0.8-0.3,0.9C599.6,464.2,599.5,464.2,599.4,464.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M617.3,464.2h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h12 c0.9,0,1.7,0.5,2.2,1.3l5.3,9.4c0.1,0.4,0,0.8-0.4,0.9C617.5,464.2,617.4,464.2,617.3,464.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M635.3,464.2h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.3,9.4c0.2,0.3,0,0.8-0.3,0.9C635.5,464.2,635.4,464.2,635.3,464.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M652.9,464.2h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h12 c0.9,0,1.7,0.5,2.2,1.3l5.3,9.4c0.1,0.4,0,0.8-0.4,0.9C653.1,464.2,653,464.2,652.9,464.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M392.9,380.1l212.2,84.1h48.2c0.4,0,0.8-0.4,0.8-0.8c0-0.3-0.2-0.6-0.5-0.7L374.7,346.1L392.9,380.1z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "411.1,340.2 641.6,440.8 628.4,418 438.4,340.2 409.1,340.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M663.2,466.7c0,0-0.1,0.2-0.3,0.6l-1,1.8l-4.3,7.4l0,0l0,0l-182.3,0.2h-47l-0.1-0.1L380,383.2l-14-27.3 c-1.6-3.2-2.9-5.6-3.7-7.3l-1-1.9c-0.2-0.4-0.3-0.6-0.3-0.6l0.4,0.6l1,1.9c0.9,1.7,2.2,4.1,3.8,7.3c3.3,6.4,8.1,15.6,14.2,27.2 l48.4,93.3l-0.2-0.1h46.8l182.3,0.2h-0.1c1.9-3.3,3.4-5.7,4.3-7.3c0.5-0.8,0.8-1.4,1.1-1.8S663.2,466.7,663.2,466.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M428.3,476.5c0.4-1.4,1-2.8,1.8-4.1c0.6-1.4,1.4-2.7,2.2-3.9c-0.4,1.4-1,2.8-1.8,4.1 C430,474,429.2,475.3,428.3,476.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "139.2,356.5 123,476.2 133.6,476.3 149.9,365.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "124,335.7 120.6,345.8 187.1,476.7 417.3,476.5 422,468.6 317.6,424  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "124,335.7 191.2,468.7 422,468.6 350.4,337.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M124,335.7l226.4,1.3h0.1l0.1,0.1c21.9,40.1,46.2,84.6,71.7,131.3l0.2,0.4h-2.4l-228.9,0.1h-0.1v-0.1 L124,335.7l67.4,132.9l-0.2-0.1l228.9-0.2h1.9l-0.2,0.4l-71.6-131.3l0.2,0.1L124,335.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M151.9,351.9l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C152.1,351.9,152,351.9,151.9,351.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M170.1,352l-12.2,0c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.1,0.4-0.1,0.8-0.4,0.9C170.3,352,170.2,352,170.1,352z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M187.6,352.2l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C187.8,352.1,187.7,352.2,187.6,352.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M205.1,352.3l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C205.2,352.3,205.1,352.3,205.1,352.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M158.7,366.1l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.2,0.3,0,0.8-0.3,0.9C158.9,366.1,158.8,366.1,158.7,366.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M176.6,366.2l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C176.7,366.2,176.6,366.2,176.6,366.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M194.6,366.4l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C194.7,366.4,194.6,366.4,194.6,366.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M212.1,366.5l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C212.3,366.5,212.2,366.5,212.1,366.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M166.1,380.2l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C166.3,380.2,166.2,380.2,166.1,380.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M184,380.3l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.2,0.3,0,0.8-0.3,0.9C184.2,380.3,184.1,380.3,184,380.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M202,380.5l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C202.2,380.4,202.1,380.4,202,380.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M219.6,380.6l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C219.8,380.6,219.7,380.6,219.6,380.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M173.6,394.3l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C173.8,394.2,173.7,394.3,173.6,394.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M191.5,394.4l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C191.6,394.4,191.5,394.4,191.5,394.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M209.5,394.5l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.4,2.2,1.2l5.3,9.5c0.2,0.3,0.1,0.7-0.2,0.9C209.7,394.5,209.6,394.5,209.5,394.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M227.1,394.6l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C227.2,394.6,227.1,394.6,227.1,394.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M181.1,408.3l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C181.2,408.3,181.2,408.3,181.1,408.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M198.9,408.5l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C199.1,408.4,199,408.5,198.9,408.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M216.9,408.6l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C217.1,408.6,217,408.6,216.9,408.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M234.5,408.7l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C234.7,408.7,234.6,408.7,234.5,408.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M188.5,422.4l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C188.7,422.4,188.6,422.4,188.5,422.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M206.4,422.5l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.4c0.2,0.3,0.1,0.8-0.3,1C206.6,422.5,206.5,422.5,206.4,422.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M224.4,422.7l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l12,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C224.6,422.7,224.5,422.7,224.4,422.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M242,422.8l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C242.2,422.8,242.1,422.8,242,422.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M196,436.5l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C196.2,436.5,196.1,436.5,196,436.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M213.9,436.6l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C214,436.6,213.9,436.6,213.9,436.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M231.9,436.7l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1L225,425 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.2,0.3,0,0.8-0.3,0.9C232,436.7,231.9,436.7,231.9,436.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M249.4,436.9l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.8c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.2,0.3,0.1,0.8-0.3,0.9C249.7,436.8,249.6,436.9,249.4,436.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M203.5,450.5l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.2,0.3,0,0.8-0.3,0.9C203.7,450.5,203.6,450.5,203.5,450.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M221.3,450.7l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C221.5,450.7,221.4,450.7,221.3,450.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M239.3,450.8l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1L220,440c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.2,0.4,0,0.8-0.3,0.9C239.5,450.8,239.4,450.8,239.3,450.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M256.9,450.9l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l12,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C257.1,450.9,257,450.9,256.9,450.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M210.9,464.6l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.2,0.3,0,0.8-0.3,0.9C211.1,464.6,211,464.6,210.9,464.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M228.8,464.8l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l12,0 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.2,0.3,0,0.8-0.3,0.9C229,464.7,228.9,464.8,228.8,464.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M246.8,464.9l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C247,464.9,246.9,464.9,246.8,464.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M264.4,465l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.4c0.2,0.3,0,0.8-0.3,0.9C264.6,465,264.5,465,264.4,465z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M225.6,352.4l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C225.8,352.4,225.7,352.4,225.6,352.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M243.9,352.6l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.2,0.3,0,0.8-0.3,0.9C244.1,352.5,244,352.6,243.9,352.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M261.3,352.7l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.2,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C261.5,352.7,261.4,352.7,261.3,352.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M278.8,352.8l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C278.9,352.8,278.8,352.8,278.8,352.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M232.4,366.6l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C232.5,366.6,232.5,366.6,232.4,366.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M250.3,366.8l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C250.4,366.8,250.3,366.8,250.3,366.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M268.3,366.9l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C268.4,366.9,268.3,366.9,268.3,366.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M285.9,367h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.1,0.4-0.1,0.8-0.4,0.9C286,367,285.9,367,285.9,367z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M239.9,380.7l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1L233,369 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.2,0.3,0,0.8-0.3,0.9C240,380.7,239.9,380.7,239.9,380.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M257.7,380.9l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.2,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C257.9,380.8,257.8,380.8,257.7,380.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M275.7,381l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C275.9,381,275.8,381,275.7,381z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M293.3,381.1l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.2,1.3l5.3,9.5c0.2,0.3,0,0.8-0.4,0.9C293.5,381.1,293.4,381.1,293.3,381.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M247.3,394.8l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.2,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C247.5,394.8,247.4,394.8,247.3,394.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M265.2,394.9l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l12,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C265.4,394.9,265.3,394.9,265.2,394.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M283.2,395l-12.2,0c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.3c0.2,0.3,0.1,0.8-0.3,1C283.4,395,283.3,395.1,283.2,395z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M300.8,395.2l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l12,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C300.9,395.2,300.8,395.2,300.8,395.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M254.8,408.9l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.8c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l12,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.2,0.3,0.1,0.8-0.3,0.9C255.1,408.8,254.9,408.9,254.8,408.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M272.6,409l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.2,0.3,0,0.8-0.3,0.9C272.8,409,272.7,409,272.6,409z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M290.6,409.1l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.2,0.3,0,0.8-0.3,0.9C290.8,409.1,290.8,409.1,290.6,409.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M308.2,409.2l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C308.4,409.2,308.3,409.2,308.2,409.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M262.2,422.9l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.2,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C262.4,422.9,262.3,422.9,262.2,422.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M280.1,423.1l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C280.2,423,280.2,423.1,280.1,423.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M298.1,423.2l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l12,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.2,0.3,0,0.8-0.3,0.9C298.4,423.2,298.2,423.2,298.1,423.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M315.7,423.3l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C315.9,423.3,315.8,423.3,315.7,423.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M269.7,437l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.2l5.3,9.5c0.2,0.3,0.1,0.8-0.3,0.9C269.9,437,269.8,437,269.7,437z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M287.6,437.1l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C287.7,437.1,287.6,437.1,287.6,437.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M305.6,437.3l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C305.7,437.2,305.6,437.3,305.6,437.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M323.2,437.4l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C323.4,437.4,323.3,437.4,323.2,437.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M277.2,451.1L265,451c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C277.4,451.1,277.3,451.1,277.2,451.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M295,451.2l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l12,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C295.2,451.2,295.1,451.2,295,451.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M313,451.3l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C313.2,451.3,313.1,451.3,313,451.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M330.6,451.5l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l12,0.1 c0.9,0,1.7,0.5,2.2,1.3l5.3,9.5c0.2,0.3,0,0.8-0.3,0.9C330.9,451.4,330.7,451.5,330.6,451.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M284.6,465.1l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l12,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C284.8,465.1,284.7,465.1,284.6,465.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M302.5,465.3l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C302.7,465.3,302.6,465.3,302.5,465.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M320.5,465.4l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C320.7,465.4,320.6,465.4,320.5,465.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M338.1,465.5l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C338.2,465.5,338.2,465.5,338.1,465.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M299.3,353l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C299.5,353,299.4,353,299.3,353z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M317.6,353.1l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C317.7,353.1,317.6,353.1,317.6,353.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M335,353.2l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C335.2,353.2,335.1,353.2,335,353.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M352.5,353.4l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C352.6,353.3,352.5,353.3,352.5,353.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M306.1,367.2l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C306.3,367.2,306.2,367.2,306.1,367.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M324,367.3l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C324.2,367.3,324.1,367.3,324,367.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M342,367.4l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l12,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C342.2,367.4,342.1,367.4,342,367.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M359.6,367.6l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C359.7,367.5,359.6,367.6,359.6,367.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M313.6,381.2l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C313.7,381.2,313.7,381.2,313.6,381.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M331.4,381.4l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C331.6,381.4,331.5,381.4,331.4,381.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M349.4,381.5l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C349.6,381.5,349.5,381.5,349.4,381.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M367,381.6l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C367.2,381.6,367.1,381.6,367,381.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M321,395.3l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C321.2,395.3,321.1,395.3,321,395.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M338.9,395.5l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l12,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C339.1,395.4,339,395.4,338.9,395.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M356.9,395.6l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C357.1,395.6,357,395.6,356.9,395.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M374.5,395.7l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l12,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C374.7,395.7,374.6,395.7,374.5,395.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M328.5,409.4l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l12,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C328.7,409.4,328.6,409.4,328.5,409.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M346.4,409.5l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C346.5,409.5,346.4,409.5,346.4,409.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M364.4,409.6l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C364.5,409.6,364.4,409.6,364.4,409.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M381.9,409.8l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.6c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C382.1,409.8,382,409.8,381.9,409.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M336,423.5l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.2,0.3,0,0.8-0.3,0.9C336.2,423.4,336.1,423.5,336,423.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M353.8,423.6l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C354,423.6,353.9,423.6,353.8,423.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M371.8,423.7l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1L365,412 c0.9,0,1.7,0.5,2.2,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C372,423.7,371.9,423.7,371.8,423.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M389.4,423.8l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1L370,413c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.2,0.3,0,0.8-0.3,0.9C389.6,423.8,389.5,423.8,389.4,423.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M343.4,437.5l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.4c0.2,0.3,0.1,0.8-0.3,0.9C343.6,437.5,343.5,437.5,343.4,437.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M361.3,437.7l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C361.4,437.6,361.4,437.7,361.3,437.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M379.3,437.8l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l12,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C379.4,437.8,379.4,437.8,379.3,437.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M396.9,437.9l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C397,437.9,396.9,437.9,396.9,437.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M350.9,451.6l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C351,451.6,351,451.6,350.9,451.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M368.7,451.7l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.2,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C368.9,451.7,368.8,451.7,368.7,451.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M386.7,451.9l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C386.9,451.8,386.8,451.9,386.7,451.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M404.3,452l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.2,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C404.5,452,404.4,452,404.3,452z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M358.3,465.7l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.2,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C358.5,465.7,358.4,465.7,358.3,465.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M376.2,465.8l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l12,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.1,0.4,0,0.8-0.4,0.9C376.4,465.8,376.3,465.8,376.2,465.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M394.2,465.9l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l11.9,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.3,9.5c0.2,0.3,0,0.8-0.3,0.9C394.4,465.9,394.3,465.9,394.2,465.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M411.8,466.1l-12.2-0.1c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1l12,0.1 c0.9,0,1.7,0.5,2.1,1.3l5.2,9.3c0.2,0.3,0.1,0.8-0.2,1C412,466,411.9,466.1,411.8,466.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M152.4,380.1L364,465.7l48.2,0.3c0.4,0,0.8-0.4,0.8-0.8c0-0.3-0.2-0.6-0.5-0.7l-278-118.6L152.4,380.1z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "170.9,340.3 400.7,442.5 387.7,419.6 198.2,340.5 168.9,340.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M422,468.6l-0.3,0.5c-0.2,0.3-0.5,0.8-0.9,1.5l-3.5,6l0,0h0l-183.9,0.3h-46.3H187l-0.1-0.1 c-19.1-37.6-35.7-70.4-47.5-93.7l-13.8-27.4c-1.6-3.2-2.8-5.7-3.7-7.3l-0.9-1.9c-0.2-0.4-0.3-0.6-0.3-0.6s0.1,0.2,0.3,0.6 s0.6,1.1,1,1.9c0.9,1.7,2.1,4.1,3.8,7.3l14,27.3c11.9,23.3,28.5,56,47.7,93.6l-0.2-0.1h46.3l183.9,0h-0.1l3.6-6l0.9-1.5 C421.9,468.7,422,468.6,422,468.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M187.1,476.7c0.4-1.4,1-2.8,1.8-4.1c0.6-1.4,1.4-2.7,2.3-3.9c-0.4,1.4-1,2.8-1.8,4.1 C188.8,474.2,188.1,475.5,187.1,476.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "184.7,213.5 169.4,335.9 179.9,335.9 195.5,222.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "169.3,192.8 166,203 233.5,333.4 463.7,331.6 468.3,323.6 363.6,279.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "169.3,192.8 237.5,325.4 468.3,323.6 395.7,192.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M169.3,192.8l226.4-0.2h0.1l0.1,0.1l72.6,130.8l0.2,0.4h-0.4h-1.9l-228.9,1.7h-0.1v-0.1L169.3,192.8 c0.8,1.5,26.7,51.6,68.4,132.4l-0.2-0.1l228.9-1.8h1.9l-0.2,0.4c-25.8-46.6-50.4-90.9-72.6-130.8l0.2,0.1L169.3,192.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M197.4,208.9h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.1,0.4,0,0.8-0.4,0.9C197.5,208.8,197.4,208.8,197.4,208.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M215.6,208.9h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.1,0.4,0,0.8-0.4,0.9C215.8,208.8,215.7,208.8,215.6,208.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M233.1,208.9h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.1,0.4,0,0.8-0.4,0.9C233.3,208.8,233.2,208.8,233.1,208.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M250.5,208.9h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.1,0.4,0,0.8-0.4,0.9C250.7,208.8,250.6,208.8,250.5,208.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M204.2,223H192c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h12 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.1,0.4,0,0.8-0.4,0.9C204.4,223,204.3,223,204.2,223z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M222.1,223h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.1,0.4,0,0.8-0.4,0.9C222.3,223,222.2,223,222.1,223z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M240.1,223h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.2,0.3,0,0.8-0.3,0.9C240.3,223,240.2,223,240.1,223z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M257.7,223h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.3,9.4c0.2,0.3,0,0.8-0.3,0.9C257.9,223,257.8,223,257.7,223z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M211.8,237h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.1,0.4,0,0.8-0.4,0.9C212,237,211.9,237,211.8,237z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M229.7,237h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.2,0.3,0,0.8-0.3,0.9C229.8,237,229.8,237,229.7,237z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M247.7,237h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h12 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.1,0.4,0,0.8-0.4,0.9C247.9,237,247.8,237,247.7,237z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M265.3,237h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.2,0.3,0,0.8-0.3,0.9C265.4,237,265.3,237,265.3,237z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M219.4,251h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.2l5.4,9.4c0.2,0.3,0,0.8-0.3,0.9C219.6,251,219.5,251,219.4,251z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M237.2,251H225c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.2l5.4,9.4c0.2,0.4,0,0.8-0.4,0.9C237.4,251,237.3,251,237.2,251z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M255.2,251H243c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.2l5.4,9.4c0.2,0.4,0,0.8-0.4,0.9C255.4,251,255.3,251,255.2,251z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M272.8,251h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.2l5.4,9.4c0.2,0.4,0,0.8-0.4,0.9C273,251,272.9,251,272.8,251z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M226.9,265.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1H220 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.2,0.3,0,0.8-0.3,0.9C227.1,265,227,265.1,226.9,265.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M244.8,265.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.3,9.3c0.2,0.3,0.1,0.8-0.2,1C245,265,244.9,265.1,244.8,265.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M262.8,265.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.3c0.2,0.3,0.1,0.8-0.2,1C263.1,265,262.9,265.1,262.8,265.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M280.4,265.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h12 c0.9,0,1.7,0.5,2.2,1.3l5.3,9.3c0.2,0.3,0.1,0.8-0.2,1C280.6,265,280.5,265.1,280.4,265.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M234.5,279.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h12 c0.9,0,1.7,0.5,2.2,1.3l5.3,9.3c0.2,0.3,0.1,0.8-0.2,1C234.8,279,234.6,279.1,234.5,279.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M252.4,279.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.3c0.2,0.3,0.1,0.8-0.2,1C252.7,279.1,252.5,279.1,252.4,279.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M270.4,279.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.3c0.2,0.3,0.1,0.7-0.2,1C270.7,279.1,270.5,279.1,270.4,279.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M288,279.1h-12.3c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1H281 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.2,0.4,0,0.8-0.4,0.9C288.1,279.1,288.1,279.1,288,279.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M242.1,293.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.1,0.4,0,0.8-0.4,0.9C242.2,293.1,242.1,293.1,242.1,293.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M259.9,293.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1H253 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.2,0.3,0,0.8-0.3,0.9C260.1,293.1,260,293.1,259.9,293.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M277.9,293.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1H271 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.1,0.4,0,0.8-0.4,0.9C278.1,293.1,278,293.1,277.9,293.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M295.5,293.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.2,0.3,0,0.8-0.3,0.9C295.7,293.1,295.6,293.1,295.5,293.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M249.6,307.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.2l5.4,9.4c0.2,0.3,0,0.8-0.3,0.9C249.8,307.1,249.7,307.1,249.6,307.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M267.5,307.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.2l5.4,9.4c0.2,0.3,0,0.8-0.3,0.9C267.7,307.1,267.6,307.1,267.5,307.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M285.5,307.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h12 c0.9,0,1.7,0.5,2.2,1.2l5.4,9.4c0.2,0.3,0,0.8-0.3,0.9C285.7,307.1,285.6,307.1,285.5,307.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M303.1,307.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.2l5.4,9.4c0.2,0.3,0,0.8-0.4,0.9C303.2,307.1,303.2,307.1,303.1,307.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M257.2,321.1H245c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.2,0.3,0,0.8-0.4,0.9C257.4,321.1,257.3,321.1,257.2,321.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M275,321.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h12 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.1,0.4,0,0.8-0.4,0.9C275.2,321.1,275.1,321.1,275,321.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M293,321.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.1,0.4,0,0.8-0.4,0.9C293.2,321.1,293.1,321.1,293,321.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M310.6,321.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h12 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.1,0.4,0,0.8-0.4,0.9C310.8,321.1,310.7,321.1,310.6,321.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M271.1,208.9h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.1,0.4,0,0.8-0.4,0.9C271.2,208.8,271.1,208.8,271.1,208.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M289.3,208.9h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.1,0.4,0,0.8-0.4,0.9C289.5,208.8,289.4,208.8,289.3,208.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M306.8,208.9h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.1,0.4,0,0.8-0.4,0.9C307,208.8,306.9,208.8,306.8,208.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M324.2,208.9H312c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h12 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.1,0.4,0,0.8-0.4,0.9C324.4,208.8,324.3,208.8,324.2,208.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M278,223h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h12 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.1,0.4,0,0.8-0.4,0.9C278.2,223,278.1,223,278,223z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M295.8,223h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.1,0.4,0,0.8-0.4,0.9C296,223,295.9,223,295.8,223z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M313.8,223h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.1,0.4,0,0.8-0.4,0.9C314,223,313.9,223,313.8,223z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M331.4,223h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.4-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.3,9.4c0.2,0.3,0,0.8-0.3,0.9C331.6,223,331.5,223,331.4,223z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M285.5,237h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.1,0.4,0,0.8-0.4,0.9C285.7,237,285.6,237,285.5,237z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M303.4,237h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.2,0.3,0,0.8-0.3,0.9C303.6,237,303.5,237,303.4,237z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M321.4,237h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h12 c0.9,0,1.7,0.5,2.2,1.3l5.3,9.4c0.2,0.3,0,0.8-0.3,0.9C321.6,237,321.5,237,321.4,237z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M339,237h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.2,0.3,0,0.8-0.3,0.9C339.2,237,339.1,237,339,237z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M293.1,251h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.2l5.4,9.4c0.2,0.3,0,0.8-0.3,0.9C293.3,251,293.2,251,293.1,251z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M310.9,251h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1H304 c0.9,0,1.7,0.5,2.2,1.2l5.4,9.4c0.2,0.4,0,0.8-0.4,0.9C311.1,251,311,251,310.9,251z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M329,251h-12.3c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1H322 c0.9,0,1.7,0.5,2.2,1.2l5.4,9.4c0.2,0.4,0,0.8-0.3,0.9C329.1,251,329.1,251,329,251z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M346.5,251h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.2l5.4,9.4c0.2,0.4,0,0.8-0.4,0.9C346.7,251,346.6,251,346.5,251z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M300.6,265.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.1,0.4,0,0.8-0.4,0.9C300.8,265,300.7,265.1,300.6,265.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M318.5,265.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h12 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.1,0.4,0,0.8-0.4,0.9C318.7,265,318.6,265.1,318.5,265.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M336.5,265.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.2,0.3,0,0.8-0.3,0.9C336.7,265,336.6,265.1,336.5,265.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M354.1,265.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h12 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.3c0.2,0.3,0.1,0.8-0.2,1C354.3,265,354.2,265.1,354.1,265.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M308.2,279.1H296c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.1,0.4,0,0.8-0.4,0.9C308.4,279.1,308.3,279.1,308.2,279.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M326.1,279.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.1,0.4,0,0.8-0.4,0.9C326.2,279.1,326.1,279.1,326.1,279.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M344.1,279.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.1,0.4,0,0.8-0.4,0.9C344.2,279.1,344.2,279.1,344.1,279.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M361.7,279.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.1,0.4,0,0.8-0.4,0.9C361.8,279.1,361.7,279.1,361.7,279.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M315.8,293.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.1,0.4,0,0.8-0.4,0.9C315.9,293.1,315.8,293.1,315.8,293.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M333.6,293.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.2,0.3,0,0.8-0.3,0.9C333.8,293.1,333.7,293.1,333.6,293.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M351.6,293.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h12 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.1,0.4,0,0.8-0.4,0.9C351.8,293.1,351.7,293.1,351.6,293.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M369.2,293.1H357c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.2,0.3,0,0.8-0.3,0.9C369.4,293.1,369.3,293.1,369.2,293.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M323.3,307.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.2l5.4,9.4c0.2,0.3,0,0.8-0.3,0.9C323.5,307.1,323.4,307.1,323.3,307.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M341.2,307.1H329c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.2l5.4,9.4c0.2,0.3,0,0.8-0.4,0.9C341.4,307.1,341.3,307.1,341.2,307.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M359.2,307.1H347c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.2l5.4,9.4c0.2,0.3,0,0.8-0.4,0.9C359.4,307.1,359.3,307.1,359.2,307.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M376.8,307.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.2l5.4,9.4c0.2,0.3,0,0.8-0.4,0.9C377,307.1,376.9,307.1,376.8,307.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M330.9,321.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h12 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.1,0.4,0,0.8-0.4,0.9C331.1,321.1,331,321.1,330.9,321.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M348.8,321.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h12 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.1,0.4,0,0.8-0.4,0.9C348.9,321.1,348.8,321.1,348.8,321.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M366.8,321.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.2,0.3,0,0.8-0.3,0.9C366.9,321.1,366.8,321.1,366.8,321.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M384.3,321.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h12 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.1,0.4,0,0.8-0.4,0.9C384.5,321.1,384.4,321.1,384.3,321.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M344.8,208.9h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.1,0.4,0,0.8-0.4,0.9C344.9,208.8,344.9,208.8,344.8,208.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M363,208.9h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.1,0.4,0,0.8-0.4,0.9C363.2,208.8,363.1,208.8,363,208.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M380.5,208.9h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h12 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.1,0.4,0,0.8-0.4,0.9C380.7,208.8,380.6,208.8,380.5,208.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M397.9,208.9h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1H391 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.2,0.4,0,0.8-0.4,0.9C398.1,208.8,398,208.8,397.9,208.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M351.7,223h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.1,0.4,0,0.8-0.4,0.9C351.8,223,351.7,223,351.7,223z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M369.5,223h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.2,0.3,0,0.8-0.3,0.9C369.7,223,369.6,223,369.5,223z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M387.5,223h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.1,0.4,0,0.8-0.4,0.9C387.7,223,387.6,223,387.5,223z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M405.1,223h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.2,0.3,0,0.8-0.3,0.9C405.3,223,405.2,223,405.1,223z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M359.2,237H347c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.2,0.4,0,0.8-0.4,0.9C359.4,237,359.3,237,359.2,237z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M377.1,237h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.2,0.3,0,0.8-0.3,0.9C377.3,237,377.2,237,377.1,237z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M395.1,237h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h12 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.2,0.3,0,0.8-0.3,0.9C395.3,237,395.2,237,395.1,237z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M412.7,237h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.1,0.4,0,0.8-0.4,0.9C412.8,237,412.8,237,412.7,237z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M366.8,251h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.2l5.4,9.4c0.2,0.3,0,0.8-0.3,0.9C367,251,366.9,251,366.8,251z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M384.6,251h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.2l5.4,9.4c0.2,0.4,0,0.8-0.4,0.9C384.8,251,384.7,251,384.6,251z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M402.7,251h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.2l5.4,9.4c0.2,0.4,0,0.8-0.4,0.9C402.8,251,402.7,251,402.7,251z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M420.2,251H408c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h12 c0.9,0,1.7,0.5,2.2,1.2l5.4,9.4c0.2,0.4,0,0.8-0.4,0.9C420.4,251,420.3,251,420.2,251z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M374.4,265.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.3c0.2,0.3,0.1,0.8-0.2,1C374.6,265,374.5,265.1,374.4,265.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M392.2,265.1H380c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.1,0.4,0,0.8-0.4,0.9C392.4,265,392.3,265.1,392.2,265.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M410.2,265.1H398c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.2,0.3,0,0.8-0.3,0.9C410.4,265,410.3,265.1,410.2,265.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M427.8,265.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.1,0.4,0,0.8-0.4,0.9C428,265,427.9,265.1,427.8,265.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M381.9,279.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1H375 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.1,0.4,0,0.8-0.4,0.9C382.1,279.1,382,279.1,381.9,279.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M399.8,279.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.1,0.4,0,0.8-0.4,0.9C399.9,279.1,399.9,279.1,399.8,279.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M417.8,279.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.1,0.4,0,0.8-0.4,0.9C417.9,279.1,417.9,279.1,417.8,279.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M435.4,279.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.3c0.2,0.3,0.1,0.7-0.2,1C435.7,279.1,435.5,279.1,435.4,279.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M389.5,293.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.2,0.3,0,0.8-0.3,0.9C389.7,293.1,389.6,293.1,389.5,293.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M407.3,293.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.2,0.3,0,0.8-0.3,0.9C407.5,293.1,407.4,293.1,407.3,293.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M425.3,293.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h12 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.1,0.4,0,0.8-0.4,0.9C425.5,293.1,425.4,293.1,425.3,293.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M442.9,293.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1H436 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.2,0.3,0,0.8-0.3,0.9C443.1,293.1,443,293.1,442.9,293.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M397,307.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.2l5.4,9.4c0.2,0.3,0,0.8-0.4,0.9C397.2,307.1,397.1,307.1,397,307.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M414.9,307.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1H408 c0.9,0,1.7,0.5,2.2,1.2l5.4,9.4c0.2,0.3,0,0.8-0.4,0.9C415.1,307.1,415,307.1,414.9,307.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M432.9,307.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1H426 c0.9,0,1.7,0.5,2.2,1.2l5.4,9.4c0.2,0.3,0,0.8-0.3,0.9C433.1,307.1,433,307.1,432.9,307.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M450.5,307.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h12 c0.9,0,1.7,0.5,2.2,1.2l5.4,9.4c0.2,0.3,0,0.8-0.3,0.9C450.7,307.1,450.6,307.1,450.5,307.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M404.6,321.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.1,0.4,0,0.8-0.4,0.9C404.8,321.1,404.7,321.1,404.6,321.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M422.5,321.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h12 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.2,0.3,0,0.8-0.3,0.9C422.6,321.1,422.6,321.1,422.5,321.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M440.5,321.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.2,0.3,0,0.8-0.3,0.9C440.7,321.1,440.6,321.1,440.5,321.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M458.1,321.1h-12.2c-0.7,0-1.4-0.4-1.8-1l-5.5-9.7c-0.2-0.3,0-0.8,0.3-0.9c0.1,0,0.2-0.1,0.3-0.1h11.9 c0.9,0,1.7,0.5,2.2,1.3l5.4,9.4c0.1,0.4,0,0.8-0.4,0.9C458.2,321.1,458.1,321.1,458.1,321.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M198.1,237l212.2,84.1h48.2c0.4,0,0.8-0.4,0.8-0.8c0-0.3-0.2-0.6-0.5-0.7L179.9,203L198.1,237z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "216.3,197.1 446.8,297.7 433.6,274.9 243.6,197.1 214.2,197.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M468.3,323.6c0,0-0.1,0.2-0.3,0.5l-0.8,1.5l-3.5,6.1l0,0l0,0l-183.9,1.7l-46.3,0.4h-0.2l-0.1-0.1 c-19.4-37.5-36.2-70.1-48.2-93.4l-14-27.3l-3.7-7.3c-0.4-0.8-0.7-1.5-0.9-1.9S166,203,166,203l0.4,0.6l1,1.9l3.8,7.3l14.2,27.2 l48.4,93.3l-0.2-0.1l46.3-0.4l183.9-1.3h-0.1l3.5-6c0.4-0.6,0.7-1.1,0.9-1.5L468.3,323.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M233.5,333.4c0.4-1.4,1-2.8,1.8-4.1c0.6-1.4,1.3-2.7,2.2-3.9c-0.4,1.4-1,2.8-1.8,4.1 C235.1,330.9,234.4,332.2,233.5,333.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sun--inject-16"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 345.8426,
    y1: 89.1545,
    x2: 415.9826,
    y2: 89.1545
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 3e-8,
    style: {
      stopColor: "#E73964"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6A632"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 380.9,
    cy: 89.2,
    r: 35.1
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 48.525 295.4586)",
    className: "st9",
    cx: 380.9,
    cy: 89.2,
    rx: 35.1,
    ry: 35.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000058591345520382819470000000639945338168813202_",
    gradientUnits: "userSpaceOnUse",
    x1: 352.27,
    y1: 88.66,
    x2: 409.05,
    y2: 88.66
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 3e-8,
    style: {
      stopColor: "#E73964"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6A632"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000058591345520382819470000000639945338168813202_)"
    },
    cx: 380.7,
    cy: 88.7,
    r: 28.4
  }), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st11",
    cx: 380.7,
    cy: 88.7,
    r: 28.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000171690234606007760990000006012066109174016191_",
    gradientUnits: "userSpaceOnUse",
    x1: 358.2288,
    y1: 88.6726,
    x2: 403.1349,
    y2: 88.6726
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 3e-8,
    style: {
      stopColor: "#E73964"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6A632"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000171690234606007760990000006012066109174016191_)"
    },
    cx: 380.7,
    cy: 88.7,
    r: 22.5
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152256965854428944640000009417895638069356425_",
    gradientUnits: "userSpaceOnUse",
    x1: 377.2009,
    y1: 129.59,
    x2: 377.7298,
    y2: 129.59
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 3e-8,
    style: {
      stopColor: "#E73964"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6A632"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000152256965854428944640000009417895638069356425_)"
    },
    d: "M377.5,138.9c-0.2-3.1-0.3-6.2-0.2-9.3 c-0.1-3.1,0-6.2,0.2-9.3c0.2,3.1,0.3,6.2,0.2,9.3C377.8,132.7,377.7,135.8,377.5,138.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070819779317910269460000017329361747802957737_",
    gradientUnits: "userSpaceOnUse",
    x1: 354.6859,
    y1: 123.6296,
    x2: 364.5349,
    y2: 123.6296
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 3e-8,
    style: {
      stopColor: "#E73964"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6A632"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000070819779317910269460000017329361747802957737_)"
    },
    d: "M364.5,115.1c0.1,0.1-2,3.9-4.7,8.6 c-1.6,2.9-3.3,5.7-5.1,8.4c-0.1-0.1,2-3.9,4.7-8.6S364.4,115.1,364.5,115.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000090287884031443952290000001699754981664917690_",
    gradientUnits: "userSpaceOnUse",
    x1: 340.48,
    y1: 111.135,
    x2: 351.26,
    y2: 111.135
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 3e-8,
    style: {
      stopColor: "#E73964"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6A632"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000090287884031443952290000001699754981664917690_)"
    },
    d: "M351.3,106.8c-1.6,1.6-3.4,3.1-5.2,4.5 c-1.8,1.5-3.6,2.9-5.5,4.1c1.6-1.6,3.4-3.1,5.2-4.5C347.5,109.5,349.3,108.1,351.3,106.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054983527226262533330000006439550438526300322_",
    gradientUnits: "userSpaceOnUse",
    x1: 395.7,
    y1: 121.995,
    x2: 399.86,
    y2: 121.995
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 3e-8,
    style: {
      stopColor: "#E73964"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6A632"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000054983527226262533330000006439550438526300322_)"
    },
    d: "M399.9,129.7c-0.3-0.7-0.5-1.5-0.6-2.3 c-0.3-1.4-0.8-3.4-1.4-5.5s-1.1-4-1.6-5.4c-0.3-0.7-0.5-1.5-0.6-2.3c0.4,0.7,0.7,1.4,1,2.2c0.5,1.4,1.1,3.3,1.7,5.4s1,4.1,1.2,5.6 C399.8,128.2,399.9,128.9,399.9,129.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000104695144480681301040000016857251604982103963_",
    gradientUnits: "userSpaceOnUse",
    x1: 409.67,
    y1: 107.91,
    x2: 422.63,
    y2: 107.91
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 3e-8,
    style: {
      stopColor: "#E73964"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6A632"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000104695144480681301040000016857251604982103963_)"
    },
    d: "M422.6,113.6c-2.3-1.7-4.5-3.5-6.6-5.5 c-2.2-1.8-4.3-3.8-6.3-5.8c2.3,1.7,4.5,3.5,6.6,5.5C418.5,109.6,420.6,111.5,422.6,113.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000109024145468005282230000005574755700175863482_",
    gradientUnits: "userSpaceOnUse",
    x1: 412.84,
    y1: 90.2467,
    x2: 431.35,
    y2: 90.2467
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 3e-8,
    style: {
      stopColor: "#E73964"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6A632"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000109024145468005282230000005574755700175863482_)"
    },
    d: "M431.4,91.4c-0.9-0.1-1.8-0.2-2.7-0.4 c-1.7-0.3-4-0.6-6.5-0.9s-4.9-0.5-6.6-0.6c-0.9,0-1.8-0.1-2.7-0.2c0.9-0.1,1.8-0.2,2.7-0.1c1.7,0,4,0.2,6.6,0.4 c2.2,0.2,4.4,0.6,6.5,1.1C429.6,90.8,430.5,91,431.4,91.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062164705555824733600000008787690032361006481_",
    gradientUnits: "userSpaceOnUse",
    x1: 409.5193,
    y1: 72.2,
    x2: 431.37,
    y2: 72.2
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 3e-8,
    style: {
      stopColor: "#E73964"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6A632"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000062164705555824733600000008787690032361006481_)"
    },
    d: "M431.4,69.5c0,0.1-4.8,1.4-10.9,2.9 s-10.9,2.6-11,2.4s4.8-1.4,10.9-2.9S431.3,69.4,431.4,69.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176733989695849586740000000733676883011063698_",
    gradientUnits: "userSpaceOnUse",
    x1: 395.2162,
    y1: 52.2496,
    x2: 406.0038,
    y2: 52.2496
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 3e-8,
    style: {
      stopColor: "#E73964"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6A632"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000176733989695849586740000000733676883011063698_)"
    },
    d: "M406,44.1c0.1,0.1-2.2,3.8-5.2,8.3 s-5.5,8.1-5.6,8s2.2-3.8,5.2-8.3S405.9,44,406,44.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165216903162254457890000001831531384272023942_",
    gradientUnits: "userSpaceOnUse",
    x1: 380.34,
    y1: 49.295,
    x2: 380.9165,
    y2: 49.295
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 3e-8,
    style: {
      stopColor: "#E73964"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6A632"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000165216903162254457890000001831531384272023942_)"
    },
    d: "M380.8,38.8c0.1,1,0.1,2.1,0,3.1 c0,1.9-0.1,4.5-0.1,7.4s0,5.5,0.1,7.4c0.1,1,0.1,2.1,0,3.1c-0.2-1-0.3-2-0.3-3.1c-0.1-1.9-0.2-4.5-0.2-7.4s0.1-5.5,0.2-7.4 C380.6,40.8,380.7,39.8,380.8,38.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000162326934198426248660000015182143619305535926_",
    gradientUnits: "userSpaceOnUse",
    x1: 351.6153,
    y1: 54.22,
    x2: 361.784,
    y2: 54.22
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 3e-8,
    style: {
      stopColor: "#E73964"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6A632"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000162326934198426248660000015182143619305535926_)"
    },
    d: "M361.8,62.5c-0.1,0.1-2.5-3.6-5.3-8.2 s-5-8.4-4.9-8.4s2.5,3.6,5.3,8.2S361.9,62.5,361.8,62.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000080167505823262527780000008768796926518087054_",
    gradientUnits: "userSpaceOnUse",
    x1: 334.62,
    y1: 69.875,
    x2: 350.39,
    y2: 69.875
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 3e-8,
    style: {
      stopColor: "#E73964"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6A632"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000080167505823262527780000008768796926518087054_)"
    },
    d: "M350.4,72.2c-0.8,0-1.6-0.2-2.4-0.4 c-1.5-0.3-3.5-0.8-5.6-1.4s-4.1-1.3-5.5-1.8c-0.8-0.3-1.5-0.6-2.2-1c0.8,0.2,1.6,0.4,2.3,0.7c1.4,0.5,3.4,1.1,5.5,1.7 s4.2,1.2,5.6,1.6C348.9,71.7,349.6,71.9,350.4,72.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000006704228759055980070000002520051877766237322_",
    gradientUnits: "userSpaceOnUse",
    x1: 331.04,
    y1: 90.1498,
    x2: 345.42,
    y2: 90.1498
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 3e-8,
    style: {
      stopColor: "#E73964"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6A632"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000006704228759055980070000002520051877766237322_)"
    },
    d: "M345.4,89.5c-2.4,0.5-4.8,0.8-7.2,0.9 c-2.4,0.3-4.8,0.5-7.2,0.5c2.4-0.5,4.8-0.8,7.2-0.9C340.6,89.6,343,89.5,345.4,89.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-16"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M690.5,451.9l8.8,20.9l-0.2,4.1l-34.6-0.1c0.2-3.3,18.1-9.9,18.1-9.9l-9.2-14.3L690.5,451.9z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M693.4,465.4c0.7,0.2,1.1,0.9,1,1.6c-0.2,0.7-0.9,1.1-1.6,1c-0.7-0.2-1.2-1-1-1.7c0.3-0.7,1.1-1.1,1.8-0.8"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M699.1,476.9l0.1-2.5l-33.3,0.6c0,0-1.5,0.7-1.4,1.8L699.1,476.9z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M682.1,466.7c0,0.2,0.8,0.2,1.7,0.8s1.3,1.3,1.4,1.2s-0.1-1-1.1-1.7S682.1,466.5,682.1,466.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M678.5,468.1c0,0.2,0.7,0.5,1.3,1.2s0.7,1.5,0.9,1.5s0.3-1-0.5-1.8S678.5,468,678.5,468.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M676.4,472.5c0.2,0,0.4-0.8,0-1.7s-1.2-1.3-1.3-1.2s0.4,0.6,0.8,1.4S676.2,472.5,676.4,472.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M682.4,462.6c0.1,0.1,0.8-0.1,1.8,0s1.7,0.4,1.8,0.2s-0.6-0.8-1.8-0.8S682.4,462.5,682.4,462.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M551,313l-33.2,17.2l3.2,9.8c0,0,17.5-1,24.3-4.3s16.9-11.5,16.9-11.5L551,313z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M479,332.3c0,0,10.6-2,12.9-1.5c3.3,0.8,17,1.6,17,1.6l8.7-2.7l5.5,11c0,0-14.8,0.9-15.9,1.5 c-2.5,1.3-9.8-1.2-9.8-1.2l-9,1.2c0,0-2-1.8-0.3-3.1c1.5-1,3-1.8,4.7-2.3l-3.3-2.2c0,0-9.1,1.2-10.2-0.2S479,332.3,479,332.3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M503.1,335.6c-3.4,0.8-6.8,1.2-10.2,1.2C496.2,336.1,499.6,335.7,503.1,335.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008118105613735218220000007205649324602888589_",
    gradientUnits: "userSpaceOnUse",
    x1: 430.9281,
    y1: 307.3557,
    x2: 458.1917,
    y2: 316.3804
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 3e-8,
    style: {
      stopColor: "#E73964"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6A632"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000008118105613735218220000007205649324602888589_)"
    },
    d: "M458.9,314.1l-11.6,12.7l-4.4-3.9 c-1.7-1.5-1.9-4.1-0.4-5.9c0,0,0.1-0.1,0.1-0.1l3.4-3.7l-13.2-11.7l5.8-5.7L458.9,314.1z"
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "423.8,302 422.6,304.6 424.9,306.7 427.1,305.1  "
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M423.8,302c1.2,0.9,2.4,1.9,3.5,2.9l0.2,0.2l-0.3,0.2l-1.7,1.2l-0.6,0.4l-0.2,0.1l-0.1-0.1 c-0.8-0.8-1.6-1.5-2.2-2.1l-0.1-0.1l0.1-0.1C422.8,303.6,423.2,302.8,423.8,302c-0.3,0.9-0.6,1.8-1,2.7v-0.2c0.7,0.6,1.5,1.3,2.3,2 h-0.3l0.6-0.4l1.7-1.2v0.4C425.9,304.3,424.8,303.2,423.8,302z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 417,
    y: 308,
    transform: "matrix(0.674 -0.7387 0.7387 0.674 -90.7453 411.5691)",
    className: "st0",
    width: 8,
    height: 1.2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M417.8,311.2c0.4-0.6,0.9-1.2,1.4-1.7c0.9-1.1,2.3-2.6,3.8-4.4l0.2-0.2l0.2,0.2l0.9,0.8c0,0.7,0,0.2,0,0.4l0,0 l0,0l-0.1,0.1l-0.1,0.1l-0.2,0.2l-0.4,0.5l-0.8,0.9l-1.5,1.6c-1,1-1.8,1.8-2.3,2.4l-0.1,0.1l-0.1-0.1 C418.4,311.7,418.1,311.4,417.8,311.2c0.4,0.1,0.7,0.4,1,0.7h-0.2c0.5-0.6,1.2-1.5,2.2-2.5l1.5-1.7c0.3-0.3,0.5-0.6,0.8-0.9 l0.4-0.5l0.2-0.2l0.1-0.1l0-0.1l0,0l0,0l0,0c0,0.2,0-0.4,0,0.4l-0.9-0.8h0.4c-1.5,1.6-2.9,3-3.9,4.1 C419,310.1,418.4,310.6,417.8,311.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000082358078298984413410000005305103117592919190_",
    gradientUnits: "userSpaceOnUse",
    x1: 425.2042,
    y1: 293.7714,
    x2: 440.8089,
    y2: 298.9368
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 3e-8,
    style: {
      stopColor: "#E73964"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6A632"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000082358078298984413410000005305103117592919190_)"
    },
    points: "427.4,306.3 432.7,303.8  442.9,292.7 434.5,285 424.5,296 422.5,301.9  "
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M424.5,296c0.9,0.6,1.8,1.3,2.6,2c1.5,1.3,3.7,3.2,6.1,5.3h-0.4l1.1-1.2c2.4-2.6,4.6-5,6.2-6.7 c0.8-0.9,1.5-1.5,1.9-2c0.2-0.3,0.5-0.5,0.8-0.7c-0.2,0.3-0.4,0.6-0.6,0.8c-0.4,0.5-1,1.2-1.8,2.1c-1.5,1.8-3.7,4.2-6.1,6.8 l-1.1,1.2l-0.2,0.2l-0.2-0.2c-2.4-2.1-4.5-4-6-5.4C426,297.5,425.3,296.8,424.5,296z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M463.4,292.1c0,0,35.5-1.5,38.4-0.9c4.2,0.9,31.7-6.2,31.7-6.2l11.8,16.5c0,0-40.2,8.3-46.7,7.1 s-34.9-4.9-34.9-4.9L463.4,292.1z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M435,306.5c0,0,2.4-6.1,3.4-7.3s17.1-7,17.1-7l10-0.6l-0.9,14l-5.4-1.6l-7.8,3.2l-3.9,2.5l-1.2,3 c0,0-3.2,2.2-4.2-1.2c0,0-2.7,0.2-3.4-1.5c-1-0.1-2-0.3-2.9-0.7C434.4,308.4,435,306.5,435,306.5z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M447.8,311.5c-0.7,1.1-1.6,2.2-2.5,3.1c-0.9,1-1.8,2-2.9,2.8c0.7-1.1,1.6-2.2,2.5-3.1 C445.7,313.2,446.7,312.3,447.8,311.5z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M649.2,450.4l6.8,22.1l-0.1,4.1l-34.6,0.4c0.2-3.3,18-10.1,18-10.1l-8.8-14.2L649.2,450.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160871280568754117060000018322094870816395670_",
    gradientUnits: "userSpaceOnUse",
    x1: 617.6796,
    y1: 397.3578,
    x2: 707.3264,
    y2: 427.0326
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 3e-8,
    style: {
      stopColor: "#E73964"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6A632"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000160871280568754117060000018322094870816395670_)"
    },
    points: "641.5,355.3 696.4,459.9  674.2,466 643.5,415 622.3,383.4  "
  }), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M650,465.3c0.7,0.2,1.1,0.9,1,1.6c-0.2,0.7-0.9,1.1-1.6,1c-0.7-0.2-1.2-1-1-1.7c0.3-0.7,1-1.1,1.8-0.9"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M655.9,476.6l0.1-2.5l-33.3,1.1c0,0-1.5,0.7-1.3,1.8L655.9,476.6z"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M638.8,466.7c0,0.2,0.8,0.2,1.7,0.8s1.3,1.2,1.4,1.2s-0.1-1-1.1-1.7S638.7,466.5,638.8,466.7z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M635.1,468.2c0,0.2,0.7,0.4,1.3,1.1s0.8,1.5,0.9,1.5s0.3-1-0.5-1.8S635.1,468.1,635.1,468.2z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M633.1,472.6c0.2,0,0.4-0.8-0.1-1.7s-1.2-1.3-1.3-1.1s0.4,0.6,0.8,1.4S633,472.6,633.1,472.6z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M639,462.6c0.1,0.2,0.8-0.1,1.8,0s1.7,0.4,1.8,0.2s-0.6-0.7-1.8-0.8S638.9,462.5,639,462.6z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M546.3,250l20.8,30.5c3.5,5.2,7.7,13.5-0.8,18.7l0,0c-7.7,4-14.1-1.5-17.4-6.4c-1.6-2.3-2.9-4.2-3-4.4 c0,0-8.2,4.6-14-2.7c-2.8-3.5-8-11.3-12.6-18.3c-4.9-7.6-3.2-17.7,3.9-23.2l0.7-0.6C531.9,238.1,541,241.8,546.3,250z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M545.9,288.4c3.4-2.6,6-6.2,7.4-10.3c0,0,2,7.4-5.9,12.4L545.9,288.4z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M523.2,270.2c0.2,0.1,1.1-1,2.7-1.6c1-0.3,2.1-0.6,3.1-0.8c0.1-0.1-0.2-0.3-0.9-0.3c-0.9,0-1.8,0.1-2.6,0.5 c-0.8,0.3-1.5,0.8-2.1,1.5C523.1,269.8,523.1,270.1,523.2,270.2z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M535.5,262.6c0.2-0.1,0.5-1.4,1.7-2.6s2.4-1.9,2.4-2.1s-0.3-0.1-0.9,0.1c-0.8,0.4-1.5,0.9-2.1,1.6 c-0.6,0.6-1,1.4-1.2,2.2C535.3,262.3,535.4,262.6,535.5,262.6z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M536.9,264.9c0.3,0.4,0.9,0.6,1.4,0.2c0,0,0,0,0,0c0.5-0.3,0.6-0.9,0.3-1.4c-0.3-0.4-0.9-0.6-1.4-0.2 c0,0,0,0,0,0C536.7,263.8,536.6,264.4,536.9,264.9z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M525.9,272.6c0.3,0.4,0.9,0.6,1.4,0.2c0,0,0,0,0,0c0.5-0.3,0.6-0.9,0.3-1.4c-0.3-0.4-0.9-0.6-1.4-0.2 c0,0,0,0,0,0C525.7,271.5,525.6,272.2,525.9,272.6z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M537.3,272.9c-0.7,0.3-1.4,0.6-2.1,1.1c-0.3,0.2-0.6,0.4-0.8,0.2c-0.3-0.3-0.4-0.6-0.5-1l-0.8-2.9 c-1.2-4-2.4-7.3-2.5-7.2s0.7,3.4,2,7.4l0.9,2.9c0.1,0.5,0.3,0.9,0.7,1.2c0.3,0.1,0.5,0.1,0.8,0c0.2-0.1,0.4-0.2,0.5-0.3 C536.2,273.9,536.8,273.4,537.3,272.9z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M531.9,256.5c0.3,0.2,1.2-0.7,2.5-1.5s2.5-1.2,2.5-1.5c0-0.2-0.4-0.3-1-0.3c-0.8,0.1-1.5,0.3-2.2,0.7 c-0.7,0.4-1.2,0.9-1.6,1.6C531.8,256,531.8,256.4,531.9,256.5z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M521.2,267.1c0.3,0.1,1.1-0.8,2.3-1.6s2.3-1.4,2.3-1.7c0-0.2-0.4-0.2-0.9-0.1c-1.5,0.3-2.7,1.3-3.5,2.5 C521.1,266.6,521.1,267,521.2,267.1z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M549.9,255.9c0.1-0.1,3.9-5.4,7.6-0.3c3.7,5.2-2.2,7.8-2.3,7.7S549.9,255.9,549.9,255.9z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M555.4,260.3c0,0,0.1,0,0.3,0c0.3-0.1,0.5-0.2,0.7-0.5c0.4-0.9,0.2-2-0.4-2.7c-0.3-0.5-0.7-0.8-1.2-1.1 c-0.3-0.3-0.8-0.3-1.2-0.2c-0.3,0.1-0.4,0.4-0.3,0.6c0,0.2,0.1,0.3,0.1,0.3s-0.2,0-0.3-0.2c-0.1-0.2-0.1-0.3,0-0.5 c0.1-0.2,0.2-0.4,0.4-0.5c0.5-0.2,1.1-0.2,1.5,0.1c0.5,0.3,1,0.7,1.4,1.2c0.7,0.9,0.9,2.2,0.3,3.2c-0.2,0.3-0.6,0.4-0.9,0.5 C555.5,260.4,555.4,260.3,555.4,260.3z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M541,275.7c-0.2-0.1,0.7-1.1,0.8-2.6c0-0.6,0-1.3-0.2-1.9c-0.1-0.5-0.1-0.8-0.1-0.8s0.2,0.2,0.4,0.7 c0.3,0.6,0.4,1.3,0.3,2c0,0.7-0.3,1.4-0.7,1.9C541.3,275.6,541.1,275.8,541,275.7z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M509.4,266.9c-0.3,0.5-0.4,1.2-0.1,1.7c0.5,0.8,1.4,1.1,2.3,0.9c0.9-0.3,1.5-1,1.7-1.9 c-0.1,0.4-0.2,0.7-0.2,1.1c0,0.9,0.7,1.6,1.6,1.7c0.7,0,1.4-0.5,1.6-1.2l0,0c0.5,0.2,1,0.5,1.4,0.8l0,0l0.1,0.1 c0.3,0.2,0.6,0.4,0.9,0.5l0,0l4.2,2.3c-1.3-2.3-3.6-5.2-4.9-7.5c3.2-2.3,5.4-5.8,6-9.7c0.3-2.1,0.2-4.4,1.2-6.2 c1.4-2.4,4.3-3.3,7-4h-0.2c1.5-0.2,3-0.2,4.4,0.2c2.4,4.6,5.7,8.7,9.8,11.9c0.6,0.5,2,1.4,2.8,1.2c1.5-0.3,1-1.8,1.3-2.9 c0.3-0.9,1-1.6,1.8-2c-0.6-2.2-1.3-4.4-2.2-6.5l-0.5-2.4l-1.7-1.9c-2.3-1.1-0.7-3.7-2.6-5.3s-4.6-3.1-7.1-2.4l0,0 c-2.3,0.5-4.6,2-5.3,4.3c-2.2-2.5-6.1-3.1-9.2-2c-3.6,1.5-6.8,4-9.1,7.1c-1.5,2.1-2.3,5.1-3,9c-0.3,1.7,1,5.8,0.9,7.5L509.4,266.9z "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039106089895477070710000014685047182760402313_",
    gradientUnits: "userSpaceOnUse",
    x1: 511.1163,
    y1: 247.0542,
    x2: 547.6627,
    y2: 259.1517
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 3e-8,
    style: {
      stopColor: "#E73964"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6A632"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000039106089895477070710000014685047182760402313_)"
    },
    d: "M524.7,232.6c0.4-0.2,11.2-3.9,17.9,1.7 s7.4,8.2,7.4,8.2c0.5,0,1,0.1,1.5,0.2c0.7,0.2,1.5,2.8,0.1,3.3c-11.8,1.6-23,8-34.9,15.9l-9.4,5.7c-2.4,1.9-3.8,1.8-3.1,0.5 c0.5-1,6.1-8.6,6.1-8.6l0.8-2l0.5-7.7c0,0-0.9-0.4-0.4-1.6S516.3,236.2,524.7,232.6z"
  }), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M511.1,257.4l0.4-0.2l1-0.7c0.9-0.6,2.2-1.4,3.8-2.4c4.3-2.4,8.8-4.5,13.5-6.2c4.7-1.7,9.4-3,14.3-4.2 c1.8-0.4,3.3-0.8,4.4-1l1.2-0.3l0.4-0.1c-0.1,0-0.3,0-0.4,0.1l-1.2,0.2c-1,0.2-2.5,0.5-4.4,0.9c-4.8,1.1-9.6,2.5-14.3,4.1 c-4.7,1.7-9.2,3.8-13.5,6.3C514.5,255.1,512.8,256.2,511.1,257.4z"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "st32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M535.9,231.4c0,0-11.2,4.6-14.4,9.6l0.4-0.6l-3.1,4.6c-0.5,0.8-1.2,1.6-2.1,1.7c1-2.8,2.5-5.3,4.4-7.6 C524.4,235,530.8,230.2,535.9,231.4z"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M536.1,231.3c-0.4,0-0.9,0-1.3,0c-1.2,0-2.3,0.2-3.5,0.5c-1.7,0.5-3.3,1.2-4.8,2.1c-1.8,1.1-3.4,2.5-4.6,4.3 c-0.6,0.9-1.2,1.9-1.6,2.9c-0.5,0.9-1,1.8-1.4,2.8c-0.3,0.9-0.7,1.7-1.2,2.5c-0.5,0.7-1.1,1.2-1.8,1.6c-2.5,1.6-4.3,2-4.3,1.8 c0.1,0.1,0.2,0.1,0.3,0.1c0.3,0,0.6-0.1,0.9-0.2c1.1-0.4,2.2-0.9,3.1-1.5c0.7-0.4,1.3-1,1.8-1.6c0.5-0.8,0.9-1.6,1.2-2.5 c0.4-0.9,0.9-1.8,1.4-2.7c0.5-1,1-1.9,1.6-2.8c1.2-1.7,2.8-3.2,4.6-4.3c1.5-0.9,3-1.6,4.7-2.1c1.1-0.3,2.3-0.5,3.4-0.6 c0.3,0,0.6,0,1,0L536.1,231.3z"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    className: "st32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M545.4,236.6c-1.8,1-3.6,1.7-5.6,2.2c-2.2,0.8-4.3,1.6-6.5,2.3c-1.7,0.5-3.6,1.2-5.2,0.8c0.3,0.8,1,1.4,1.9,1.6 c1.3,0,2.7-0.1,3.9-0.6c4.5-1.2,8.8-2.8,12.9-4.9C546.3,237.5,545.9,237,545.4,236.6"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005229019968220845720000014377363062994030757_",
    gradientUnits: "userSpaceOnUse",
    x1: 529.6175,
    y1: 235.9132,
    x2: 544.0357,
    y2: 240.6859
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 3e-8,
    style: {
      stopColor: "#E73964"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6A632"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000005229019968220845720000014377363062994030757_)"
    },
    d: "M541.9,233.6c1.5-0.2,2.4-0.3,3,0.6 c0.5,0.8,1,1.9,0.3,2.6c-0.2,0.2-0.5,0.3-0.8,0.4l-14.2,5.3c-0.5,0.2-1,0.3-1.5,0.2c-0.7-0.4-1-1.3-0.6-2c0.4-0.7,1-1.3,1.7-1.6 C533.5,236.7,537.6,234.9,541.9,233.6"
  }), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M529,242.8c-0.3-0.1-0.5-0.2-0.7-0.3c-0.5-0.5-0.7-1.2-0.5-1.9c0.5-0.9,1.2-1.7,2.2-2.1c1-0.6,2.2-1.2,3.4-1.8 c2.1-1.1,4.3-1.9,6.5-2.6c0.9-0.2,1.6-0.4,2.1-0.5l0.6-0.1l0.2-0.1h-0.2l-0.6,0.1c-0.5,0.1-1.2,0.2-2.1,0.5 c-2.3,0.6-4.5,1.5-6.6,2.6c-1.2,0.6-2.4,1.2-3.4,1.8c-1,0.5-1.8,1.3-2.2,2.2c-0.2,0.7,0,1.5,0.5,2c0.1,0.1,0.3,0.2,0.5,0.3 L529,242.8z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "511.5,252.1 519.3,247 520.1,249.7 511.3,254.9  "
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M527.9,251.7c0-0.1-3.9,1.6-8.6,3.8c-4.7,2.1-8.5,3.9-8.5,3.9s3.9-1.6,8.6-3.8S527.9,251.8,527.9,251.7z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M516.7,286.6c0,0,12.8-3,16.7-3.8c3.5-0.7,14.8-3.5,14.8-3.5c8.2-4,12.3-3.4,19.1-3.9c2.9-0.1,5.8,0.2,8.6,0.8 c7.6,1.4,14.5,5.4,19.4,11.4c5.5,6.8,12.8,15.5,15.1,17.4c3.8,3.2,14.1,16.3,14.1,16.3l-24.9,25.5l-3.6,2.8c0,0-16.2-7-23.2-14 s-24.5-25.2-24.5-25.2l-24.1-3.4L516.7,286.6z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M516.7,286.6l0.1,0.4c0.1,0.2,0.2,0.6,0.4,1l1.5,4c1.3,3.5,3.1,8.5,5.5,15l-0.1-0.1l24.1,3.3h0.1v0l20.1,20.7 c6.7,8.2,16.9,13.6,27.6,18.5h-0.2l3.6-2.8l0,0l17.8-18.2l7.2-7.3v0.3c-3-3.8-6-7.5-9.1-11c-1.5-1.8-3.1-3.4-4.8-5 c-1.7-1.6-3.2-3.2-4.7-5c-3-3.4-5.8-6.8-8.5-10.1c-1.4-1.7-2.7-3.4-4.1-4.8c-1.4-1.5-3-2.8-4.7-3.9c-6.7-4.6-14.6-6-21.5-5.8 c-3.3,0-6.7,0.3-10,0.8c-3,0.6-5.8,1.6-8.5,3l0,0l-13.2,3.1c-3.9,0.9-7.2,1.6-9.9,2.2l-6.2,1.4l-1.6,0.4L516.7,286.6l0.6-0.1 l1.6-0.4l6.2-1.4l9.9-2.3l13.2-3.2l0,0c2.7-1.4,5.6-2.4,8.6-3c3.3-0.5,6.7-0.8,10.1-0.8c1.8-0.1,3.6-0.1,5.4,0.2 c1.9,0.2,3.7,0.5,5.5,0.9c3.9,0.9,7.5,2.5,10.8,4.8c1.7,1.2,3.3,2.5,4.8,4c1.5,1.5,2.8,3.2,4.2,4.8c2.7,3.3,5.5,6.7,8.5,10.1 c1.5,1.7,3,3.4,4.7,4.9c1.7,1.6,3.3,3.3,4.8,5.1c3.1,3.5,6.1,7.2,9.1,11l0.2,0.2l-0.2,0.2l-7.2,7.3L599.7,347l0,0l-3.6,2.8 l-0.1,0.1l-0.1-0.1c-5.3-2.3-10.4-5.1-15.3-8.1c-2.4-1.5-4.6-3.1-6.7-4.9c-1-0.9-2-1.9-2.9-2.8l-2.8-2.9L548,310.5l0.1,0.1 l-24.1-3.4h0v-0.1c-2.3-6.5-4.1-11.6-5.4-15.1l-1.4-4c-0.2-0.4-0.3-0.8-0.3-1S516.7,286.6,516.7,286.6z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M551.4,307.7c3.8,0.1,7.3-1.9,9-5.3c1.6-3.4,1.5-7.4-0.4-10.6c-1.9-3.2-5-5.6-8.6-6.5 c4.7,6.5,4.6,15.2-0.1,21.7"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M549.9,282.9c0.3,0.2,0.5,0.5,0.8,0.8c0.6,0.8,1.2,1.6,1.6,2.5c1.6,2.9,2.7,6.1,3.2,9.4 c0.1,1.9-0.1,3.7-0.8,5.5c-0.5,1.4-1.1,2.8-1.8,4.1c-0.5,0.9-1.1,1.7-1.7,2.5c-0.2,0.3-0.5,0.6-0.8,0.8c0.8-1.1,1.5-2.2,2.2-3.4 c0.7-1.3,1.3-2.6,1.7-4c0.6-1.7,0.8-3.5,0.7-5.2c-0.5-3.2-1.5-6.4-3-9.3C550.9,284.1,549.9,282.9,549.9,282.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163783836550734382230000000462990839375015082_",
    gradientUnits: "userSpaceOnUse",
    x1: 530.645,
    y1: 350.331,
    x2: 673.5673,
    y2: 397.641
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 3e-8,
    style: {
      stopColor: "#E73964"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6A632"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000163783836550734382230000000462990839375015082_)"
    },
    d: "M555.2,276l35.3,24l1.6,1.3 c6.9,5.7,8.1,16.1,2.3,22.8c-0.6,0.7-1.2,1.3-1.9,1.8l0,0c-4.2,3.2-9.8,3.6-14.4,1l-30-16.7c0,0,23.6,25.7,26.7,28.5l22.2,20 l-3.5,37.8c-0.4,4.8,0.8,9.5,3.5,13.5l30.6,57.5l25.6-8.5l-26.6-57.4l13.4-34.3c4.1-8.3,5.3-15.1,3.6-24.3c0-0.1,0-0.2,0-0.3 c-1.7-11.1-20.3-25.9-20.3-25.9l-21.7-21.6l-40.2-19.9L555.2,276z"
  }), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M598.9,341.8c0,0.2,0,0.4,0,0.6c0,0.4-0.1,1-0.1,1.6c-0.2,1.5-0.3,3.5-0.6,6c-0.6,5.1-1.3,12.1-2.2,19.8 s-1.5,14.7-1.9,19.8c-0.2,2.5-0.4,4.5-0.5,6c-0.1,0.7-0.1,1.2-0.1,1.6c0,0.2,0,0.4-0.1,0.6c0-0.2,0-0.4,0-0.6c0-0.4,0-1,0-1.6 c0-1.4,0.2-3.5,0.3-6c0.3-5.1,0.9-12.1,1.7-19.8s1.7-14.7,2.3-19.8c0.3-2.5,0.6-4.5,0.8-6c0.1-0.6,0.2-1.2,0.2-1.6 C598.8,342.1,598.9,341.9,598.9,341.8z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M632.5,328.2c-0.7,0.5-1.4,1-2.2,1.4c-1.4,0.8-3.3,2-5.3,3.4s-3.8,2.7-5.1,3.7c-0.7,0.6-1.4,1.1-2.1,1.5 c0.6-0.7,1.2-1.3,1.9-1.8c3.2-2.8,6.7-5.1,10.4-7.1C630.8,328.8,631.6,328.5,632.5,328.2z"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    className: "st32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M632.4,351.3c-3.4-0.1-6.5-1.6-8.7-4.2c-0.9-1.2-1.7-2.1-2.5-3.4c-1.2-1.8-2.2-3.6-3.2-5.5c0.9,3,2.2,5.8,3.8,8.5 c1.5,2.3,3.6,4.3,5.9,5.8c2.4,1.5,5.2,2.1,8,1.7c2.8-0.5,5.2-2.3,6.3-4.9C639,350.7,635.7,351.3,632.4,351.3z"
  }))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M644,346.4c0,0,0,0.1-0.1,0.3c-0.1,0.3-0.3,0.6-0.5,0.9c-0.7,1-1.7,1.9-2.8,2.4c-1.7,0.8-3.4,1.3-5.3,1.5 c-2.3,0.3-4.5,0.1-6.7-0.5c-2.1-0.8-4-2.1-5.5-3.9c-0.6-0.8-1.2-1.6-1.7-2.4c-0.5-0.7-1-1.5-1.4-2.1c-0.7-1-1.3-2.1-1.8-3.2 c-0.2-0.4-0.4-0.8-0.5-1.3c0.2,0.4,0.5,0.8,0.7,1.2c0.6,1.1,1.3,2.1,2,3.1c0.5,0.6,1,1.3,1.5,2.1c0.5,0.8,1.1,1.6,1.7,2.3 c1.4,1.7,3.2,3,5.3,3.8c2.1,0.6,4.3,0.8,6.5,0.5c1.8-0.2,3.5-0.6,5.2-1.4c1.1-0.5,2.1-1.2,2.8-2.2c0.2-0.3,0.4-0.5,0.5-0.8 C643.9,346.5,644,346.4,644,346.4z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M590.7,353.1c0.2-0.5,0.4-1,0.6-1.4c0.5-1,1.1-2.3,1.9-3.8v0.2c-2.3-1.8-5.5-4.3-8.8-7 c-3.8-3.1-7.2-5.8-9.6-7.8h0.2l-3.4,0.7c-0.4,0.1-0.8,0.2-1.2,0.2c0.4-0.2,0.8-0.3,1.2-0.4l3.3-0.9h0.1l0.1,0.1 c2.4,1.9,5.9,4.6,9.7,7.7c3.4,2.7,6.5,5.2,8.8,7.1l0.1,0.1l-0.1,0.1l-2,3.7C591.3,352.3,591,352.7,590.7,353.1z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M632.5,398.7c0,0,13.7-34.2,13.9-34l-3-5.6l-14,35.1L632.5,398.7z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M643.5,358.7c0,0.2,0,0.3-0.1,0.5l-0.4,1.3c-0.4,1.1-0.9,2.7-1.6,4.7c-1.4,3.9-3.5,9.3-6,15.2 s-4.6,11.2-6.2,15.1c-0.8,1.9-1.4,3.4-1.8,4.6l-0.5,1.2c-0.1,0.2-0.1,0.3-0.2,0.4c0-0.2,0.1-0.3,0.1-0.5c0.1-0.4,0.3-0.8,0.4-1.3 c0.4-1.1,1-2.7,1.7-4.7c1.5-3.9,3.6-9.3,6.1-15.2s4.6-11.3,6.1-15.2c0.7-1.9,1.3-3.5,1.8-4.6l0.5-1.2 C643.3,359,643.4,358.8,643.5,358.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-16"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000147929217279510882550000011422157821463215550_",
    gradientUnits: "userSpaceOnUse",
    x1: 57.8577,
    y1: 428.5204,
    x2: 98.6766,
    y2: 442.0323
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 3e-8,
    style: {
      stopColor: "#E73964"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6A632"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000147929217279510882550000011422157821463215550_)"
    },
    d: "M76.1,419.2c2.6,1.3,4.6,3.5,5.6,6.3 c0.9,2.7,1.1,5.7,0.7,8.5c-0.6,5.5-3.8,11.1-7.2,15.5c-4.7-4.1-5.7-11.1-6-14.8C68.7,429.1,71.3,418.4,76.1,419.2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000028302561003619846380000003079013187761852835_",
    gradientUnits: "userSpaceOnUse",
    x1: 53.4356,
    y1: 441.8795,
    x2: 94.2545,
    y2: 455.3913
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 3e-8,
    style: {
      stopColor: "#E73964"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6A632"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000028302561003619846380000003079013187761852835_)"
    },
    d: "M80.6,458.7c-0.6-3.2,0.5-6.5,3-8.7 c2.5-2.1,5.7-3.1,8.9-2.8c1.5,0,2.9,0.7,3.9,1.8c0.8,1.2,0.8,2.8,0.1,4c-0.7,1.2-1.7,2.2-2.9,2.9C89.6,458.4,85.2,460.1,80.6,458.7 "
  }), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M74.7,475.6c0-0.4,0.1-0.8,0.2-1.1c0.2-0.8,0.3-1.8,0.6-3.1c0.5-3.4,1.6-6.7,3.2-9.8c1.6-3.1,4-5.6,7-7.5 c0.9-0.5,1.9-1,2.9-1.3c0.3-0.1,0.5-0.2,0.8-0.2c0.1,0,0.2,0,0.3,0c-1.3,0.5-2.6,1.1-3.8,1.8c-2.9,1.9-5.2,4.4-6.8,7.4 c-1.5,3-2.6,6.3-3.2,9.7c-0.3,1.3-0.5,2.3-0.7,3C74.9,474.9,74.8,475.3,74.7,475.6z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M74.8,427.5c0,0.2,0.1,0.3,0.1,0.5c0,0.4,0.1,0.8,0.1,1.4c0.1,1.2,0.1,3,0.2,5.2c0.2,4.4,0.3,10.5,0.2,17.3 s-0.2,12.9-0.4,17.3c-0.1,2.2-0.2,4-0.2,5.2c0,0.6-0.1,1-0.1,1.4c0,0.2,0,0.3-0.1,0.5c0-0.2,0-0.3,0-0.5c0-0.4,0-0.8,0-1.4 c0-1.3,0.1-3.1,0.1-5.2c0.1-4.4,0.2-10.5,0.3-17.3s0-12.9-0.1-17.3c0-2.2-0.1-4-0.1-5.2c0-0.6,0-1,0-1.4 C74.8,427.9,74.8,427.7,74.8,427.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000006683260100726699960000015393049648364141744_",
    gradientUnits: "userSpaceOnUse",
    x1: 50.8624,
    y1: 449.6532,
    x2: 91.6813,
    y2: 463.165
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 3e-8,
    style: {
      stopColor: "#E73964"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6A632"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000006683260100726699960000015393049648364141744_)"
    },
    d: "M72.6,462.1c-1.1-6.8-5.5-12.6-11.7-15.7 c-1.5-0.7-3.6-1.2-4.9-0.1s-1,3.2-0.4,4.8c2.8,6.8,9.4,11.3,16.8,11.3"
  }), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M61.7,451.6c0.3,0.1,0.7,0.3,1,0.4c0.4,0.2,0.8,0.4,1.1,0.6c0.5,0.3,1,0.6,1.4,0.9c0.6,0.4,1.1,0.8,1.6,1.2 c0.6,0.5,1.2,1,1.7,1.6c1.2,1.3,2.4,2.7,3.3,4.2c0.9,1.5,1.6,3.2,2.2,4.9c0.2,0.7,0.4,1.5,0.5,2.3c0.1,0.7,0.2,1.3,0.3,2 c0.1,0.6,0.1,1.1,0.1,1.7c0,0.4,0,0.8,0,1.3c0,0.4,0,0.7-0.1,1.1c-0.1,0,0.1-1.5-0.2-4c-0.1-0.7-0.2-1.3-0.3-2 c-0.1-0.8-0.3-1.5-0.6-2.2c-0.5-1.7-1.3-3.3-2.2-4.8c-0.9-1.5-2-2.9-3.2-4.2c-0.6-0.6-1.1-1.1-1.7-1.6c-0.5-0.4-1-0.8-1.6-1.2 C63,452.4,61.6,451.7,61.7,451.6z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M707.2,460.8c0,0,0.3,0.1,0.7,0.3c0.6,0.3,1.2,0.7,1.7,1.1c3.7,2.8,6.1,6.8,6.9,11.4c0.1,0.7,0.2,1.3,0.2,2 c0,0.3,0,0.5,0,0.8c-0.1,0-0.1-1.1-0.5-2.7c-1-4.4-3.3-8.3-6.8-11.1C708.1,461.5,707.2,460.9,707.2,460.8z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M714.7,455c0.5,1,0.9,2,1.1,3c0.6,1.9,1.4,4.6,2.1,7.6s1.2,5.7,1.5,7.7c0.2,1.1,0.4,2.2,0.4,3.2 c-0.3-1-0.6-2.1-0.7-3.2c-0.4-2-1-4.7-1.7-7.7s-1.4-5.6-2-7.6C715.1,457.1,714.9,456.1,714.7,455z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M725.3,466.1c-0.6,1.7-1.2,3.4-1.7,5.1c-0.3,1.8-0.5,3.5-0.6,5.3c-0.4-1.8-0.4-3.7,0.1-5.4 C723.4,469.3,724.1,467.6,725.3,466.1z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M100,465.8c0.6,0.3,1.1,0.7,1.5,1.1c2.2,2.1,3.9,4.7,4.9,7.6c0.2,0.6,0.4,1.2,0.4,1.8 c-0.8-1.9-1.8-3.8-2.9-5.7C102.7,469,101.4,467.3,100,465.8z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M103.3,457c0.6,0.8,1,1.7,1.4,2.6c1,2.2,1.8,4.4,2.4,6.7c0.6,2.3,1.1,4.6,1.4,7c0.2,1,0.2,2,0.2,3 c-0.2-1-0.4-1.9-0.5-2.9c-0.4-2.3-0.9-4.6-1.5-6.9c-0.6-2.3-1.4-4.5-2.3-6.7C104,458.9,103.6,457.9,103.3,457z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Icon--inject-16"
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 98.6,
    cy: 236.3,
    r: 30.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168098702941842818570000006046119139622266547_",
    gradientUnits: "userSpaceOnUse",
    x1: 90.67,
    y1: 236.2449,
    x2: 107.6,
    y2: 236.2449
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 3e-8,
    style: {
      stopColor: "#E73964"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6A632"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000168098702941842818570000006046119139622266547_)"
    },
    d: "M104.1,220.4c1.6-0.1-13.4,17.7-13.4,17.7 H97l-5.3,14l15.9-18.2h-6.8L104.1,220.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008850621594712415230000010655866268532664749_",
    gradientUnits: "userSpaceOnUse",
    x1: 67.9899,
    y1: 236.1895,
    x2: 154.3955,
    y2: 236.1895
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 3e-8,
    style: {
      stopColor: "#E73964"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6A632"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000008850621594712415230000010655866268532664749_)"
    },
    d: "M154,239c-0.5-0.6-1.4-0.6-2-0.1 c-0.3,0.2-0.4,0.5-0.4,0.9c-2.1-0.1-6.1-0.1-10.6,0c-5.6,0.1-10.3,0.3-11.8,0.5c0.4-3.3,0.3-6.6-0.3-9.9c-0.5-2.9-1.5-5.7-2.9-8.3 c-0.5-1-1-1.9-1.7-2.8c-0.4-0.7-0.9-1.3-1.4-1.9l-0.9-1.1c-0.1-0.1-0.2-0.2-0.3-0.4c0.1,0.1,0.2,0.3,0.3,0.4l0.9,1.2 c0.5,0.6,0.9,1.2,1.3,1.9c0.6,0.9,1.1,1.8,1.6,2.8c1.3,2.6,2.3,5.4,2.8,8.3c2.6,14.2-5.2,28.3-18.6,33.6c-2.7,1.1-5.5,1.8-8.4,2 c-1.5,0.1-3,0.2-4.5,0.1c-1.5-0.1-3-0.3-4.5-0.7c-3.1-0.6-6-1.8-8.7-3.4c-5.6-3.2-10-8.2-12.5-14.2c-1.2-2.9-2-5.9-2.3-9 c-0.1-1.5-0.2-3-0.1-4.6c0.1-1.5,0.3-3,0.6-4.4c0.3-1.4,0.7-2.8,1.2-4.2c4.2-11,14.3-18.6,26-19.6c3.9-0.3,7.7,0.1,11.4,1.3 c2.8,0.9,5.4,2.1,7.9,3.8c0.9,0.6,1.8,1.2,2.6,1.9c0.6,0.5,1.2,1,1.8,1.6l1,1c0.1,0.1,0.2,0.2,0.4,0.3c-0.1-0.1-0.2-0.2-0.3-0.3 l-1-1.1c-0.5-0.6-1.1-1.1-1.7-1.6c-0.8-0.7-1.6-1.4-2.5-2c-2.4-1.7-5.1-3.1-7.9-4c-8.4-2.7-17.5-1.7-25.1,2.8 c-4.7,2.8-8.6,6.9-11.2,11.7c-0.7,1.3-1.3,2.6-1.8,4c-0.5,1.4-0.9,2.9-1.2,4.3c-0.3,1.5-0.5,3-0.6,4.5c-0.1,1.6,0,3.1,0.1,4.7 c0.3,3.2,1,6.3,2.3,9.2c2.6,6.1,7.1,11.2,12.9,14.6c2.8,1.6,5.8,2.8,8.9,3.4c1.5,0.3,3.1,0.6,4.6,0.7c1.5,0.1,3.1,0,4.6-0.1 c3-0.2,5.9-0.9,8.6-2c5.1-2,9.6-5.4,13-9.7c3.3-4.3,5.4-9.3,6.1-14.5c1.4,0.1,6.2,0.2,11.9,0.1c4.5-0.1,8.5-0.2,10.6-0.4 c0,0.3,0.1,0.5,0.3,0.8c0.5,0.6,1.4,0.6,2,0.1C154.5,240.5,154.6,239.6,154,239z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404Vector);
export default __webpack_public_path__ + "static/media/404-vector.3583c0bc51cd76142ab2146f87e44461.svg";
export { ForwardRef as ReactComponent };